/* =============================================================================
 * Portal list views — desk filter + sort controls
 *
 * Uses frappe's REAL components, loaded unmodified from /assets/frappe/js/...
 * on demand - only on the routes below, so no other website page pays for them:
 *     frappe.ui.FieldSelect   ui/filters/field_select.js
 *     frappe.ui.Filter        ui/filters/filter.js
 *     frappe.ui.FilterGroup   ui/filters/filter_list.js
 *     frappe.ui.SortSelector  ui/sort_selector.js
 * Nothing is copied or re-implemented, so they stay in step with the installed
 * frappe version. frappe.model / frappe.meta / frappe.perm and the template
 * engine those components need are already in frappe-web.bundle.js, which every
 * website page loads.
 *
 * Data goes through frappe's own list endpoint, frappe.www.list.get_list_data
 * - the one every Web Form list on the site already calls - with two extra
 * arguments it does not natively understand: the desk `filters` format and an
 * `order_by`. plushvie_portal installs an override for those through
 * override_whitelisted_methods (hooks.py -> portal/list_api.py), which also
 * applies the same row-level scoping the stock portal list applies
 * (portal/scoping.py). There is no second, app-specific list API to call.
 *
 * Two routes, two different host pages, one shared toolbar/filter/sort layer:
 *
 *   Web Form list routes (/tasks/list, /issues/list) - frappe's own
 *   WebFormList (web_form_list.js) already owns the table, row click,
 *   checkbox, delete and Load More; only its fetch_data is swapped, for one
 *   that sends the filter and sort arguments, keeping the same endpoint and
 *   the same {message: [rows]} contract. The instance is claimed inside its
 *   own constructor (claim_web_form_list) so the swap is in place before the
 *   list can fetch anything, which is what keeps the page down to a single
 *   list request. See init_web_form_list().
 *
 *   Plain portal list routes (/orders, /invoices, /project) - ordinary portal
 *   list pages (frappe/www/list.html), not Web Forms. There is no reusable
 *   list object here at all: rows are normally server-rendered HTML fragments
 *   and "Load More" is inline Jinja JS baked into the page. This file owns the
 *   whole list here - quick filters, table, pagination - built from scratch,
 *   with the columns, status pills and quick filters the desk shows for the
 *   same doctype. Every route runs the same code; everything doctype-specific
 *   is read off the doctype's own meta. See init_portal_list().
 * ========================================================================== */
(function () {
	"use strict";

	// frappe's own component sources, loaded in dependency order. Not copied
	// into this app, so they track the installed frappe version.
	var COMPONENTS = [
		// frappe.model.sync lives in sync.js, which frappe-web.bundle.js does NOT
		// include. Without it locals.DocType is never populated, frappe.get_meta()
		// returns nothing, and both the filter and sort components degrade
		// silently. Must load before them.
		"/assets/frappe/js/frappe/model/sync.js",
		"/assets/frappe/js/frappe/ui/filters/field_select.js",
		"/assets/frappe/js/frappe/ui/filters/filter.js",
		"/assets/frappe/js/frappe/ui/filters/filter_list.js",
		"/assets/frappe/js/frappe/ui/sort_selector.js",
	];

	/* frappe.ui.form.make_control and its control classes (ControlData,
	 * ControlSelect, ...) live in frappe/form/controls/*.js, which Task/Issue
	 * get for free because their page already loads web_form.bundle.js. The
	 * plain portal list routes (/orders, /project) never load that, and
	 * FilterGroup's own
	 * popover needs a working make_control for every filter row's value field
	 * (filter.js calls it internally) - not just this file's own quick
	 * filters. The BUILT bundle that normally provides this is 1.65MB
	 * (controls.bundle.js, covering ~40 control types this page will never
	 * use); these files cover exactly the four types those routes actually
	 * need (Data, Select, Date, Check) and, like the files
	 * above, have no ES imports of their own. Link is deliberately not
	 * included - see scoping.get_filter_field_overrides for how Customer and
	 * Company (the only Link fields exposed here) are shown as constrained
	 * Selects instead, and apply_filter_field_overrides() below for how that
	 * keeps FilterGroup's own value-control construction consistent with it.
	 *
	 * ControlDate additionally needs the air-datepicker library itself plus
	 * one language pack - date.js only calls into $.fn.datepicker at runtime
	 * (inside make_picker()), so neither is a load-order dependency of date.js
	 * loading cleanly, only of a date control actually being *used* without
	 * throwing (confirmed the hard way: ControlDate loaded fine, then threw
	 * "Cannot read properties of undefined (reading 'language')" the moment a
	 * user actually saw the quick filters, since $.fn.datepicker didn't exist
	 * yet). Both are vendored, MIT-licensed, dependency-free files (0 ES
	 * imports) already shipped as part of frappe's own build
	 * (node_modules/air-datepicker), but not reachable under
	 * /assets/frappe/... the way the files above are - not built from a
	 * source tree under any app's public/ folder, only pulled in by the
	 * bundler at build time. Copied byte-for-byte into this app's own
	 * public/js/vendor/ so they can be served and raw-loaded the same way;
	 * English only, matching this route's actual language, not all ~30 packs
	 * air-datepicker ships (date.js falls back to "en" for any language it
	 * has no pack for, so this is never a hard requirement, only a nicety for
	 * other locales). */
	var CONTROL_COMPONENTS = [
		"/assets/frappe/js/frappe/form/controls/base_control.js",
		"/assets/frappe/js/frappe/form/controls/base_input.js",
		"/assets/frappe/js/frappe/form/controls/data.js",
		"/assets/frappe/js/frappe/form/controls/select.js",
		"/assets/plushvie_portal/js/vendor/air-datepicker.js",
		"/assets/plushvie_portal/js/vendor/air-datepicker.en.js",
		"/assets/frappe/js/frappe/form/controls/date.js",
		"/assets/frappe/js/frappe/form/controls/check.js",
	];

	function load_scripts(urls) {
		return urls.reduce(function (chain, url) {
			return chain.then(function () {
				return new Promise(function (resolve, reject) {
					$.ajax({ url: url, dataType: "script", cache: true })
						.done(resolve)
						.fail(function () { reject(new Error("failed to load " + url)); });
				});
			});
		}, Promise.resolve());
	}

	function components_ready() {
		return !!(frappe.ui && frappe.ui.FilterGroup && frappe.ui.SortSelector);
	}

	function load_components() {
		if (components_ready()) {
			return Promise.resolve();
		}
		// sequential: filter.js needs FieldSelect, filter_list.js needs Filter
		return load_scripts(COMPONENTS);
	}

	/* Resolve once the components are actually USABLE, not merely fetched.
	 *
	 * load_components() resolving is not the same thing as
	 * frappe.ui.FilterGroup existing. Each file is pulled with
	 * `$.ajax({dataType: "script"})`, whose promise settles when jQuery has
	 * handed the response to its script converter - and the class the file
	 * declares is not reliably observable on the next microtask. Checking
	 * immediately after therefore fails intermittently, and it did: on this
	 * bench, roughly half of a repeated 6-route sweep threw
	 * "filter/sort components unavailable" and dropped the whole toolbar, while
	 * a probe of the same page a few seconds later showed every global present.
	 * A real user on a slow connection is in exactly that window.
	 *
	 * So this waits for the thing that actually matters instead of asserting it,
	 * and only gives up - with the same error, into the same fallback that hands
	 * the page back to frappe's own list - if the globals never arrive at all.
	 * The ceiling is well under WEB_FORM_MOUNT_TIMEOUT, so the watchdog stays
	 * the outer bound. */
	var COMPONENT_WAIT_MS = 10000;

	function await_components() {
		return new Promise(function (resolve, reject) {
			var waited = 0;
			(function poll() {
				if (components_ready()) return resolve();
				waited += 100;
				if (waited > COMPONENT_WAIT_MS) {
					return reject(new Error("filter/sort components unavailable"));
				}
				setTimeout(poll, 100);
			})();
		});
	}

	/* Verbatim port of frappe.ui.form.make_control's own definition
	 * (frappe/public/js/frappe/form/controls/control.js) - a mechanical
	 * fieldtype -> class-name lookup, nothing desk-specific about it. Guarded
	 * so it never overwrites the real one where that's already loaded
	 * (Task/Issue's page, via web_form.bundle.js). */
	function ensure_make_control() {
		var need_control_components = !frappe.ui.form.make_control;
		var chain = need_control_components ? load_scripts(CONTROL_COMPONENTS) : Promise.resolve();
		return chain.then(function () {
			if (need_control_components) {
				frappe.ui.form.make_control = function (opts) {
					var control_class_name = "Control" + opts.df.fieldtype.replace(/ /g, "");
					if (frappe.ui.form[control_class_name]) {
						return new frappe.ui.form[control_class_name](opts);
					}
					console.log("Invalid Control Name: " + opts.df.fieldtype);
				};
			}
			// Unconditionally, on every portal list page - see the function's
			// own comment for why a page that HAS the real ControlLink needs
			// this more than one that does not.
			install_link_fallback();
			patch_id_field_type();
		});
	}

	/* Every Link filter on a portal list is a plain text box.
	 *
	 * This is the app's one rule for Link filters, and it is applied to every
	 * portal list page regardless of which controls that page happens to carry.
	 * It exists for two different reasons on the two kinds of page, and the
	 * second one is the more serious:
	 *
	 * **Plain list routes** (/orders, /invoices, /project) cannot load the real
	 * ControlLink at all (see the CONTROL_COMPONENTS note above), and
	 * make_control's own fallback for a fieldtype it has no class for is to
	 * console.log and return undefined. That is not survivable inside frappe's
	 * own unmodified filter.js: Filter.make_field() calls f.refresh() on
	 * whatever make_control() returned, with no check - so picking ANY Link
	 * field in the Filter popover threw a TypeError and left the popover
	 * half-built.
	 *
	 * **Web Form list routes** (/tasks/list, /issues/list, ...) DO carry the real
	 * ControlLink, via web_form.bundle.js, and that is precisely the problem: it
	 * answers by calling frappe.desk.search.search_link, which runs
	 * frappe.get_list(<target doctype>) with permissions ON. A portal Customer
	 * holds no DocPerm on almost anything a portal document links to, so that
	 * endpoint does not degrade - it raises PermissionError. Measured on this
	 * bench: of the ~130 Link and Dynamic Link fields across the eight portal
	 * doctypes, ~120 targets are unreadable, so nearly every field the Filter
	 * popover offers 403'd the moment it was picked. /issues/list was worse
	 * still: its issue_type and priority QUICK filters are Link fields, built by
	 * frappe's own WebFormList.make_filters() straight from the stored Web Form
	 * rows, so that toolbar failed on load rather than on a click.
	 *
	 * Overwriting the real control is therefore the fix, not a degradation, and
	 * its blast radius is exactly the filter controls: a Web Form rewrites its
	 * own Link fields to Autocomplete server-side (process_link_field), so
	 * nothing else on any of these pages constructs a ControlLink.
	 *
	 * A text box, and not something richer, is the deliberate choice. filter.js
	 * only ever reaches a Link control for the few conditions it does NOT
	 * already scrub Link down to Data for (= / != and the nested-set ones - see
	 * FilterValueUtils.set_fieldtype), so this is the value box for an
	 * exact-match condition. The Link fields whose value sets are small and safe
	 * to enumerate are already served a constrained Select by
	 * scoping.get_filter_field_overrides - that map is now an improvement on top
	 * of a filter that works, rather than the only thing standing between a user
	 * and a 403. And offering live autocomplete over the rest would surface
	 * other customers' record names as the user types, which is exactly what
	 * that function exists to avoid.
	 *
	 * get_label_value() is the one Link-specific method the filter layer calls
	 * (FilterValueUtils.get_selected_label, for the filter's own button label);
	 * it is copied verbatim from link.js.
	 *
	 * Idempotent, and scoped to this page's own JS context (a fresh page load
	 * per route), so nothing outside the portal list routes is touched. */
	function install_link_fallback() {
		if (!frappe.ui.form.ControlData) return;
		if (frappe.ui.form.__portal_link_fallback) return;
		frappe.ui.form.__portal_link_fallback = true;

		frappe.ui.form.ControlLink = class PortalControlLink extends frappe.ui.form.ControlData {
			get_label_value() {
				return this.$input ? this.$input.val() : "";
			}
		};
		// Real frappe has ControlDynamicLink extend ControlLink, and filter.js
		// scrubs Dynamic Link to Data anyway - this is only here so the field
		// picker cannot find a gap either.
		frappe.ui.form.ControlDynamicLink = frappe.ui.form.ControlLink;
	}

	/* frappe.model.std_fields (frappe/public/js/frappe/model/model.js) types
	 * the standard "name"/ID field as fieldtype: "Link" - confirmed the hard
	 * way: filter_list.js auto-adds a "name" filter row the FIRST time the
	 * Filter popover is opened at all (set_popover_events(): no existing
	 * filters -> this.add_filter(this.doctype, "name")), and field_select.js
	 * builds its field list straight from this array, so that default row
	 * hit the exact same missing-ControlLink gap on the very first click -
	 * before a user had touched anything else. base_list.js's own desk quick
	 * filters never hit this: they hardcode ID to `{fieldtype:"Data",
	 * condition:"like"}` themselves rather than reading std_fields for it
	 * (get_standard_filter_fields() above does the same). This mirrors that
	 * same, already-established treatment onto the one path that doesn't -
	 * frappe's own FieldSelect - rather than leaving an inconsistency where
	 * "ID" behaves as a plain text filter everywhere in this UI except the
	 * split second a fresh popover auto-adds it. Scoped to this page's own
	 * JS context (a fresh page load per route), so Task/Issue - which loads
	 * the real ControlLink and should keep the desk's real Link search on ID
	 * - is untouched by it. */
	function patch_id_field_type() {
		var std = frappe.model.std_fields;
		if (!std) return;
		var name_field = std.filter(function (d) { return d.fieldname === "name"; })[0];
		if (name_field) name_field.fieldtype = "Data";
	}

	/* field_select.js (the Filter popover's own fieldname picker, part of
	 * COMPONENTS above) builds its autocomplete on a bare global `Awesomplete`
	 * reference - it has no import of its own, because on Task/Issue's page
	 * link.js's ES import of the `awesomplete` package (bundled into
	 * web_form.bundle.js) already puts it on window before field_select.js
	 * ever runs. /orders never loads that bundle - confirmed the hard way:
	 * the fieldname picker threw "Awesomplete is not defined" the moment its
	 * popover opened. Same vendoring approach as air-datepicker above: a
	 * single MIT-licensed, dependency-free, 0-import file already shipped as
	 * part of frappe's own build (node_modules/awesomplete), not reachable
	 * under /assets/frappe/... on its own, copied byte-for-byte into this
	 * app's public/js/vendor/. Guarded so Task/Issue's page - which already
	 * has a real Awesomplete - never fetches or overwrites it. */
	function ensure_awesomplete() {
		var need_library = !window.Awesomplete;
		var chain = need_library
			? load_scripts(["/assets/plushvie_portal/js/vendor/awesomplete.min.js"])
			: Promise.resolve();
		return chain.then(function () {
			/* field_select.js calls me.awesomplete.get_item(value) - not part
			 * of vanilla Awesomplete at all, but a small prototype extension
			 * link.js adds globally (frappe/form/controls/link.js line ~840),
			 * confirmed the hard way: without it, picking any field in the
			 * Filter popover throws "get_item is not a function" the moment
			 * a field is selected. Verbatim port - 5 lines, no Link-specific
			 * logic, just a lookup by value against Awesomplete's own
			 * internal `_list`. Guarded the same way link.js itself guards
			 * it, so this is a no-op wherever the real one is already there. */
			if (window.Awesomplete && !Awesomplete.prototype.get_item) {
				Awesomplete.prototype.get_item = function (value) {
					return this._list.find(function (item) { return item.value === value; });
				};
			}
		});
	}

	/* frappe.ui.Filter renders through frappe.render_template("edit_filter") and
	 * SortSelector through "sort_selector". Those templates are compiled into the
	 * desk bundle, which the website does not load, so fetch the same source
	 * files and register them. Without this, Filter throws
	 * "Template edit_filter not found" and the popover stays empty. */
	var TEMPLATES = {
		edit_filter: "/assets/frappe/js/frappe/ui/filters/edit_filter.html",
		sort_selector: "/assets/frappe/js/frappe/ui/sort_selector.html",
	};

	function load_templates() {
		frappe.templates = frappe.templates || {};
		var pending = Object.keys(TEMPLATES).filter(function (name) {
			return !frappe.templates[name];
		});
		return Promise.all(
			pending.map(function (name) {
				return new Promise(function (resolve) {
					$.get(TEMPLATES[name])
						.done(function (html) { frappe.templates[name] = html; })
						.fail(function () { log(new Error("template " + name), "template"); })
						.always(resolve);
				});
			})
		);
	}

	// ---------------------------------------------------------------- helpers

	function log(e, where) {
		// A failure here must never take the list down with it.
		console.error("[portal list] " + where, e);
	}

	function wait_for(test, done, tries) {
		tries = tries || 0;
		if (test()) return done();
		if (tries > 200) return;
		setTimeout(function () { wait_for(test, done, tries + 1); }, 100);
	}

	/* The filter components read a few things the desk boot provides and the
	 * website boot does not. Fill them in rather than patch the components. */
	function install_shims(meta_response) {
		frappe.boot = frappe.boot || {};
		if (!frappe.boot.additional_filters_config) {
			frappe.boot.additional_filters_config = meta_response.additional_filters_config || {};
		}
		if (!frappe.boot.nested_set_doctypes) {
			frappe.boot.nested_set_doctypes = meta_response.nested_set_doctypes || [];
		}
		if (!frappe.boot.user) frappe.boot.user = { can_read: [] };
		if (!frappe.user_roles) frappe.user_roles = meta_response.user_roles || [];

		/* frappe.defaults (frappe/defaults.js) is not part of
		 * frappe-web.bundle.js, and unlike the filter/sort components it cannot
		 * simply be lazy-loaded like the rest: its get_default() reads
		 * frappe.boot.user.defaults and its in_user_permission() path reads
		 * frappe.boot.user.user_permissions, neither of which the website boot
		 * carries - so the real file would throw on the same call this is here
		 * to answer.
		 *
		 * It is reached from exactly one place in this page's render path, and
		 * only for Currency columns: frappe.form.formatters.Currency ->
		 * frappe.meta.get_field_precision() -> get_default("currency_precision").
		 * Confirmed the hard way - Grand Total on /invoices formatted to a bare
		 * "24900" because the formatter threw on `frappe.defaults` being
		 * undefined and render_cell() fell back to the raw value.
		 *
		 * So this is deliberately not a port of defaults.js: it is a lookup
		 * against the scalar site defaults the server sends in `user_defaults`,
		 * carrying frappe's own JSON.parse-or-string tail. The user-permission
		 * branches are dropped rather than stubbed - they answer a question
		 * about Link-field defaults on a form, which no portal list ever asks.
		 * Guarded, so a page that does have the real frappe.defaults keeps
		 * it. Web Form routes do NOT: web_form.bundle.js does not carry
		 * defaults.js either, which is why the form routes install this too -
		 * see the dispatch at the foot of this file. */
		install_defaults_shim(meta_response.user_defaults);

		// filter_list.js hides its popover on desk route changes; there is no
		// router on the website, so give it a no-op to subscribe to.
		if (!frappe.router) frappe.router = { on: function () {} };
		else if (!frappe.router.on) frappe.router.on = function () {};
	}

	function install_defaults_shim(user_defaults) {
		frappe.boot = frappe.boot || {};
		if (!frappe.boot.user) frappe.boot.user = { can_read: [] };
		if (!frappe.boot.user.defaults) {
			frappe.boot.user.defaults = user_defaults || {};
		}
		if (frappe.defaults) return;

		frappe.defaults = {
			get_default: function (key) {
				// Read through frappe.boot every time rather than closing over it:
				// a Web Form page's own inline script assigns `frappe.boot = {...}`
				// wholesale (web_form.html / web_list.html, `{% block script %}`),
				// which runs after this file and would otherwise leave this
				// reaching into the object it replaced.
				var boot_user = (frappe.boot && frappe.boot.user) || {};
				var value = (boot_user.defaults || {})[key];
				if (value === undefined || value === null || value === "") return undefined;
				try {
					return JSON.parse(value);
				} catch (e) {
					return value;
				}
			},
		};
		frappe.defaults.get_user_default = frappe.defaults.get_default;
	}

	/* Fetches the DocType meta bundle (+ the couple of boot values above) that
	 * the filter/sort components need, and syncs it into locals.DocType /
	 * locals.DocField exactly the way the desk's own request layer does. Used
	 * once per page by whichever integration is active. */
	function load_meta(doctype) {
		return frappe
			.call({
				method: "plushvie_portal.web.list_api.get_meta",
				type: "GET",
				args: { doctype: doctype },
			})
			.then(function (r) {
				var payload = (r && r.message) || {};
				install_shims(payload);
				// The server returns the meta bundle on frappe.response.docs, the
				// same place getdoctype puts it. On the desk, request.js auto-syncs
				// that; the website request layer does not, so sync it here with
				// the identical call request.js makes.
				if (r && r.docs && frappe.model && frappe.model.sync) {
					frappe.model.sync(r);
				}
				if (!frappe.get_meta || !frappe.get_meta(doctype)) {
					throw new Error("doctype meta unavailable for " + doctype);
				}
				apply_filter_field_overrides(doctype, payload.filter_field_overrides);
				// {} for every doctype but CRM Deal today - see STATUS_COLORS.
				// Before mount(), so the first row rendered already has its
				// pill colour.
				set_status_colors(doctype, payload.status_colors);
				return load_templates();
			});
	}

	/* {} for every doctype except Sales Order today (see
	 * scoping.get_filter_field_overrides on the server for why). Rewrites the
	 * JUST-SYNCED meta's own field entries - not a separate lookup this file
	 * keeps to itself - so both this file's own quick filters AND
	 * frappe.ui.Filter's internal value-control construction (which reads
	 * fieldtype off the exact same synced meta) treat Customer/Company as a
	 * constrained Select consistently, everywhere, with no special-casing
	 * needed inside the desk's own unmodified filter.js. */
	function apply_filter_field_overrides(doctype, overrides) {
		if (!overrides) return;
		var meta = frappe.get_meta(doctype);
		if (!meta || !meta.fields) return;
		meta.fields.forEach(function (df) {
			var override = overrides[df.fieldname];
			if (!override) return;
			df.fieldtype = override.fieldtype;
			df.options = override.options;
		});
	}

	// ------------------------------------------------------------- URL state
	// Matches the desk's own encoding: one query param per field, the value
	// either bare (for "=") or a JSON ["operator", value] pair. The desk URL
	// carries one condition per field too, so anything beyond that simply is
	// not persisted - same behaviour, not a limitation added here.

	function make_url_codec(doctype, path, default_sort_by, default_sort_order) {
		var sort_by = default_sort_by;
		var sort_order = default_sort_order;

		return {
			get sort_by() { return sort_by; },
			get sort_order() { return sort_order; },
			set_sort: function (by, order) { sort_by = by; sort_order = order; },

			write: function (filters) {
				var params = new URLSearchParams(window.location.search);
				Array.prototype.slice.call(params.keys()).forEach(function (k) {
					if (k !== "sort_by" && k !== "sort_order") params.delete(k);
				});
				filters.forEach(function (f) {
					var fieldname = f[1], operator = f[2], value = f[3];
					params.set(fieldname, operator === "=" ? value : JSON.stringify([operator, value]));
				});
				params.set("sort_by", sort_by);
				params.set("sort_order", sort_order);
				var qs = params.toString();
				window.history.replaceState(null, "", qs ? path + "?" + qs : path);
			},

			read: function () {
				var params = new URLSearchParams(window.location.search);
				var out = [];
				params.forEach(function (value, key) {
					if (key === "sort_by") { sort_by = value; return; }
					if (key === "sort_order") { sort_order = value; return; }
					if (!frappe.meta.has_field(doctype, key) && key !== "name") return;
					var operator = "=", val = value;
					if (value && value[0] === "[") {
						try {
							var parsed = JSON.parse(value);
							if (Array.isArray(parsed) && parsed.length === 2) {
								operator = parsed[0];
								val = parsed[1];
							}
						} catch (e) { /* not JSON: treat as a plain equals value */ }
					}
					out.push([doctype, key, operator, val]);
				});
				return out;
			},
		};
	}

	// ------------------------------------------------------------ loading state
	/* One placeholder table, shared by every portal list on the site.
	 *
	 * Both integrations render their rows only once the list request has come
	 * back, and until then the card is simply empty - on a cold cache that is a
	 * blank box for as long as the lazily-loaded filter components, the doctype
	 * meta and the list call take between them. This fills that gap with a
	 * table of the shape the real one is about to have, so the page does not
	 * jump when the rows land.
	 *
	 * It is deliberately built out of the same `<table class="table">` the real
	 * list uses, inside the same `.web-list-table` wrapper: every rule this app
	 * already has for the header bar, the row rhythm and the cell padding then
	 * applies to it unchanged, and both integrations clear it for free, because
	 * both replace the whole wrapper when they render. The explicit clears
	 * below are only for the paths that do not get that far (a failed request).
	 *
	 * `column_count` includes the two leading columns every portal table has
	 * (checkbox, Sr.) - callers pass `columns.length + 2`. Where the real count
	 * is not known yet, the fallback keeps the placeholder plausible rather
	 * than accurate; the first fetch re-renders it with the true count only if
	 * it replaced a real table, never on top of an existing placeholder, so a
	 * single load never shows two different placeholder widths. */
	var SKELETON_ROWS = 5;
	var SKELETON_FALLBACK_COLUMNS = 5;

	function render_skeleton($wrap, column_count) {
		if (!$wrap || !$wrap.length) return;

		var cols = Math.max(2, column_count || SKELETON_FALLBACK_COLUMNS);
		var head = "";
		var body_cells = "";
		for (var c = 0; c < cols; c++) {
			head += '<th><span class="portal-skeleton-bar"></span></th>';
			body_cells += '<td><span class="portal-skeleton-bar"></span></td>';
		}
		var body = "";
		for (var r = 0; r < SKELETON_ROWS; r++) body += "<tr>" + body_cells + "</tr>";

		$wrap.attr("aria-busy", "true").html(
			'<table class="table portal-skeleton" aria-hidden="true">' +
				"<thead><tr>" + head + "</tr></thead>" +
				"<tbody>" + body + "</tbody>" +
			"</table>"
		);
	}

	function has_skeleton($wrap) {
		return !!($wrap && $wrap.length && $wrap.find(".portal-skeleton").length);
	}

	function clear_skeleton($wrap) {
		if (!$wrap || !$wrap.length) return;
		$wrap.removeAttr("aria-busy").find(".portal-skeleton").remove();
	}

	// -------------------------------------------------- filter/sort toolbar
	// Shared by both integrations: the Filter button (+ its popover, built by
	// the real FilterGroup) and the SortSelector, in the desk's own markup so
	// the desk's own CSS classes (and this app's matching styling) apply
	// identically regardless of which page mounted them.

	/* The quick filters and the Filter/Sort group share one wrapping flex row,
	 * so a route with enough filter fields used to push the group onto a line
	 * of its own underneath them - the one place a toolbar action must never
	 * be. Giving the quick filters a box of their own turns that row into
	 * exactly two flex children: a filter area that wraps inside itself and
	 * grows, and the group pinned to its top right. How many filter fields a
	 * route has stops being able to move the group at all.
	 *
	 * The box has to adopt filters that do not exist yet. On a Web Form list
	 * WebFormList.make_filters() builds them from the result of a server call
	 * and appends them straight into .web-list-filters whenever that call
	 * happens to return, which is also the append race the `order` rules in
	 * the stylesheet were put there to survive. Each one is moved across as it
	 * lands - inside the observer callback, so it is moved before the browser
	 * paints and nothing is seen to jump. The stylesheet still matches a
	 * filter either way (every filter rule matches a descendant, not a direct
	 * child), so if this never runs the row just wraps the old way. */
	function build_quick_area($toolbar) {
		var $quick = $('<div class="portal-list-quick"></div>').prependTo($toolbar);

		function adopt() {
			// Moving them out mutates $toolbar too, which re-enters here once
			// with nothing left to move - childList only, so the appends into
			// $quick itself are not observed and this cannot loop.
			$toolbar.children(".frappe-control").appendTo($quick);
		}

		adopt();
		if (window.MutationObserver) {
			new MutationObserver(adopt).observe($toolbar[0], { childList: true });
		}

		return $quick;
	}

	function build_controls_block($toolbar) {
		var $right = $('<div class="portal-list-controls"></div>').appendTo($toolbar);

		var $filter_wrap = $(
			'<div class="filter-selector">' +
				'<div class="btn-group">' +
					'<button class="btn btn-default btn-sm filter-button">' +
						'<span class="filter-icon">' +
							(frappe.utils.icon ? frappe.utils.icon("es-line-filter", "sm") : "") +
						"</span>" +
						'<span class="button-label hidden-xs">' + __("Filter") + "</span>" +
					"</button>" +
					'<button class="btn btn-default btn-sm filter-x-button hide" title="' +
						__("Clear all filters") + '">' +
						'<span class="filter-icon">' +
							(frappe.utils.icon ? frappe.utils.icon("es-small-close", "sm") : "&times;") +
						"</span>" +
					"</button>" +
				"</div>" +
			"</div>"
		).appendTo($right);

		var $sort = $('<div class="portal-sort"></div>').appendTo($right);
		var $count = $('<div class="portal-list-count text-muted"></div>').appendTo($right);

		return { controls: $right, filter_wrap: $filter_wrap, sort: $sort, count: $count };
	}

	/* The "create a new one" action for a route that has one (today: the
	 * Quotation list's "Request a Quotation"). It lives in the toolbar rather
	 * than the page header because the header is outside .page_content, which
	 * is the only region init_portal_list() owns and rebuilds - reaching out of
	 * it would mean this file depended on the host page's markup, which is the
	 * one thing that genuinely differs between the Web Form routes and these.
	 *
	 * A plain <a>, not a button with a click handler: it is a navigation, so it
	 * should middle-click, ctrl-click and show its target in the status bar
	 * like any other link. */
	function build_create_button($controls, create) {
		return $('<a class="btn btn-primary btn-sm portal-list-create"></a>')
			.attr("href", create.href)
			.text(create.label)
			.appendTo($controls);
	}

	/* Let frappe's own Filter popover see this doctype's fields.
	 *
	 * frappe.ui.FieldSelect.build_options() - the field picker inside the
	 * popover - gates every single field, the standard ones included, on
	 * `frappe.perm.has_perm(doctype, df.permlevel, "read")`. That asks whether
	 * the user holds ordinary DocPerm read, which is the wrong question on
	 * these pages and is already answered "no" for most of them: a portal
	 * Customer holds no DocPerm on Quotation, Sales Order, Sales Invoice or
	 * Project at all - the rows reach the page because portal/scoping.py pins
	 * them to that user's own Customer and queries with ignore_permissions,
	 * mirroring erpnext's own get_transaction_list. Left alone the popover
	 * opens onto an empty field list and no filter can be added, which is
	 * exactly the gate get_standard_filter_fields() drops for the same reason.
	 *
	 * So permlevel-0 read is granted for the one doctype this page lists, and
	 * only when the user does not already have it (Task and Issue do, through
	 * real DocPerm rows, and keep the perms they have). It reaches nothing but
	 * this popover: every button on these pages that depends on a permission -
	 * WebFormList's New and Delete - asks the server through
	 * frappe.has_permission instead, and the server-side scoping is untouched,
	 * so a filter on a field this now exposes still only ever matches the
	 * user's own rows. Higher permlevels are deliberately left alone, so a
	 * restricted field stays out of the picker exactly as it would in the
	 * desk. */
	function ensure_list_read_perm(doctype) {
		try {
			if (!frappe.perm || !frappe.perm.get_perm) return;
			if (frappe.perm.has_perm(doctype, 0, "read")) return;
			var perms = frappe.perm.get_perm(doctype) || [];
			perms[0] = $.extend({ permlevel: 0 }, perms[0], { read: 1 });
			frappe.perm.doctype_perm[doctype] = perms;
		} catch (e) {
			log(e, "grant list read perm");
		}
	}

	/* Builds the real FilterGroup + SortSelector against a mounted toolbar
	 * block, seeded from the URL, wired so every change goes back through
	 * on_apply(). Returns the pieces the caller needs to keep talking to them
	 * (collecting filters, syncing the clear button). */
	function mount_filter_sort(doctype, ui, url, on_apply) {
		ensure_list_read_perm(doctype);

		var filter_x_button = ui.filter_wrap.find(".filter-x-button");

		var filter_group = new frappe.ui.FilterGroup({
			parent: ui.filter_wrap,
			doctype: doctype,
			filter_button: ui.filter_wrap.find(".filter-button"),
			filter_x_button: filter_x_button,
			default_filters: [],
			on_change: function () { on_apply(); },
		});

		// FilterGroup's own X-button handler only calls on_change() when a
		// `base_list` (a real desk ListView) is configured; the portal has none,
		// so without this the button would clear its own state and relabel
		// itself but never actually refresh the list or update the URL.
		filter_x_button.on("click", function () { on_apply(); });

		var url_filters = url.read();
		if (url_filters.length) {
			filter_group.add_filters_to_filter_group(url_filters);
			filter_group.update_filter_button();
		}
		sync_clear_button(filter_group, filter_x_button);
		// add_filters_to_filter_group() -> add_filter() -> Filter.make() sets
		// `.field` on each row as part of building its value control, which is
		// not guaranteed to have finished by this exact point in the same tick
		// (confirmed the hard way: the button read "Filters 1" correctly, since
		// update_filter_button() only counts array length, but the X button -
		// gated on count_real_filters()'s `f.field` check - stayed hidden on a
		// URL-seeded reload until the next filter change). One more check next
		// tick, after that settles, costs nothing on the common no-URL-filters
		// path (count_real_filters() is 0 either way).
		if (url_filters.length) {
			setTimeout(function () { sync_clear_button(filter_group, filter_x_button); }, 0);
		}

		var sort_selector = null;
		try {
			sort_selector = new frappe.ui.SortSelector({
				parent: ui.sort,
				doctype: doctype,
				args: { sort_by: url.sort_by, sort_order: url.sort_order },
				onchange: function (sort_by, sort_order) {
					url.set_sort(sort_by, sort_order);
					on_apply();
				},
			});
			if (sort_selector.sort_by) url.set_sort(sort_selector.sort_by, sort_selector.sort_order);
		} catch (e) {
			log(e, "sort selector");
		}

		return { filter_group: filter_group, filter_x_button: filter_x_button, sort_selector: sort_selector };
	}

	function count_real_filters(filter_group) {
		if (!filter_group) return 0;
		return filter_group.filters.filter(function (f) {
			return f.field && ![undefined, null].includes(f.get_selected_value());
		}).length;
	}

	/* The clear-all (X) button sits next to Filter and, per the desk convention
	 * being matched here, only makes sense - and should only be visible - once
	 * at least one filter is actually applied. */
	function sync_clear_button(filter_group, filter_x_button) {
		if (!filter_x_button) return;
		filter_x_button.toggleClass("hide", count_real_filters(filter_group) === 0);
	}

	// -------------------------------------------------------------- paging
	// Desk puts the page-length buttons at the BOTTOM LEFT of the list, in the
	// same row as "Load More" (base_list.js: .list-paging-area, level-left /
	// level-right) - not in the top toolbar.

	var PAGE_LENGTHS = [20, 100, 500];

	function build_page_length($footer, current, on_select) {
		var $wrap = $('<div class="portal-page-length btn-group"></div>').prependTo($footer);
		PAGE_LENGTHS.forEach(function (n) {
			$('<button type="button" class="btn btn-default btn-sm"></button>')
				.text(n)
				.toggleClass("active", n === current)
				.on("click", function () {
					$wrap.find(".btn").removeClass("active");
					$(this).addClass("active");
					on_select(n);
				})
				.appendTo($wrap);
		});
	}

	function update_count_text($count, shown, total) {
		if (!$count || !$count.length) return;
		if (total === null || total === undefined) {
			$count.text(shown ? __("{0} shown", [shown]) : "");
		} else {
			$count.text(__("{0} of {1}", [shown, total]));
		}
	}

	// -------------------------------------------------------- list data access
	// One endpoint, one request shape, one response shape, for every portal list
	// route on the site - the web form routes and /orders alike - and it is
	// frappe's own:
	//
	//     cmd=frappe.www.list.get_list_data&doctype=Issue&limit_start=0&limit=10
	//         &web_form_name=issues
	//
	// exactly the call frappe.ui.WebFormList already makes on every Web Form
	// list page on the site, POSTed the same way. Nothing here introduces a
	// second, app-specific list API.
	//
	// Two arguments the stock endpoint has no notion of ride along with it:
	// `filters` (the desk format - a JSON list of
	// [doctype, fieldname, operator, value] rows, which its own **kwargs ->
	// dict-keyed-by-fieldname handling cannot express) and `order_by` (which it
	// hardcodes). They are answered server side by an override installed through
	// override_whitelisted_methods in hooks.py, so a bench gets them by
	// installing this app - see portal/list_api.py. On any bench where that
	// override is not in place, the extra arguments are simply ignored and the
	// stock endpoint answers as it always has.
	//
	// The response keeps the stock contract too: r.message is the plain array of
	// rows. The total count for the "x of y" summary rides beside it on
	// r.total_count, the same way get_meta hands back r.docs.

	var LIST_METHOD = "frappe.www.list.get_list_data";

	/* args: {doctype, filters, order_by, limit_start, limit, web_form_name?}
	 *   ->  Promise<{rows: [], total: number|null}>
	 * Rejects like any frappe.call; each caller decides what a failed list
	 * means for its own page. */
	function fetch_list(args) {
		return frappe
			.call({
				method: LIST_METHOD,
				args: {
					doctype: args.doctype,
					filters: JSON.stringify(args.filters || []),
					order_by: args.order_by,
					limit_start: args.limit_start || 0,
					limit: args.limit,
					web_form_name: args.web_form_name,
				},
			})
			.then(function (r) {
				return { rows: (r && r.message) || [], total: r && r.total_count };
			});
	}

	/* Turn the Status column of a Web Form list into the same pill the plain
	 * portal lists (and the desk) show.
	 *
	 * frappe.ui.WebFormListRow renders every cell the same way - the field's
	 * formatted value inside `<p class="ellipsis">` - so a Status column on
	 * /tasks/list read as the bare word "Overdue" in body text while the very
	 * same status on /orders was a red pill. This paints the cell after the row
	 * is built instead of replacing the row class, so the checkbox, the row
	 * click, the selection and the delete flow all stay frappe's.
	 *
	 * The cell index is the column's index in the Web Form's own list_columns
	 * plus the two leading columns every portal table has (checkbox, Sr.), which
	 * is exactly how make_table_head() lays the header out. A doctype with no
	 * INDICATORS entry, or a list with no status column, is left alone. */
	function paint_list_status_pills(list, doctype) {
		if (!list || !INDICATORS[doctype]) return;

		var columns = list.columns || [];
		var col_index = -1;
		columns.forEach(function (col, i) {
			if (col && col.fieldname === "status") col_index = i;
		});
		if (col_index === -1) return;

		var cell_index = col_index + 2;
		(list.rows || []).forEach(function (row) {
			if (!row || !row.row || !row.doc) return;
			var $cell = $(row.row).children("td").eq(cell_index);
			// Already painted (a re-render of rows already on screen), or the
			// row has no status to show.
			if (!$cell.length || $cell.find(".indicator-pill").length) return;
			var html = status_pill_html(doctype, row.doc);
			if (!html) return;
			$cell.addClass("list-col-status").html(html);
		});
	}

	// =============================================================================
	// Web Form list routes: /tasks/list, /issues/list
	// =============================================================================

	// How long take_over() waits for mount() before handing the page back to
	// frappe's own list. Long enough that a slow connection still gets the desk
	// toolbar, short enough that a hard failure is not a blank list.
	var WEB_FORM_MOUNT_TIMEOUT = 15000;

	function is_web_form_list(value) {
		return !!(value && typeof value.fetch_data === "function" && typeof value.refresh === "function");
	}

	/* Hand frappe's WebFormList over the instant it exists - from inside its own
	 * constructor, before make_filters() has run - rather than polling for it.
	 *
	 * The constructor assigns `frappe.web_form_list = this` as its third
	 * statement and then immediately calls make_actions() and make_filters();
	 * make_filters()'s get_web_form_filters round trip is what later triggers the
	 * list's first refresh(). Polling for the instance (wait_for, 100ms) and only
	 * then loading components and meta before touching it lost that race every
	 * single time - which is exactly why the first page load used to go out
	 * with none of the filter or sort arguments the URL asked for, only to be
	 * corrected by a second request a moment later. A setter on the property
	 * closes the race
	 * outright, because this app's web_include_js script is emitted before the
	 * web form's own bundle (frappe/templates/base.html: web_include_js at line
	 * 101, `{% block script %}` - where web_form.html puts web_form.bundle.js -
	 * at line 105), and both are plain synchronous script tags.
	 *
	 * The property is handed straight back as a plain value the moment the real
	 * instance lands, so nothing downstream ever sees an accessor. */
	function claim_web_form_list(on_instance) {
		if (is_web_form_list(frappe.web_form_list)) return on_instance(frappe.web_form_list);

		var value = frappe.web_form_list;
		try {
			Object.defineProperty(frappe, "web_form_list", {
				configurable: true,
				enumerable: true,
				get: function () { return value; },
				set: function (next) {
					value = next;
					// web_form_list.js opens with frappe.provide("frappe.web_form_list"),
					// which assigns a bare {} placeholder at module load, before any
					// instance exists. Only the instance is interesting.
					if (!is_web_form_list(next)) return;
					Object.defineProperty(frappe, "web_form_list", {
						configurable: true,
						enumerable: true,
						writable: true,
						value: next,
					});
					on_instance(next);
				},
			});
		} catch (e) {
			// Never worth taking the page down for: fall back to polling, which
			// still works, just without winning the race above.
			log(e, "claim web form list");
			wait_for(
				function () { return is_web_form_list(frappe.web_form_list); },
				function () { on_instance(frappe.web_form_list); }
			);
		}
	}

	function init_web_form_list() {
		/* The doctype is NOT read off the URL.
		 *
		 * It used to be: a route -> doctype map keyed on window.location, which
		 * meant a Web Form recreated or renamed in the desk - the ordinary way
		 * out when developer mode is off and frappe refuses to edit a standard
		 * form - served its list at a path this file did not recognise, and the
		 * whole toolbar silently vanished. That is exactly what happened to
		 * /tasks/list here.
		 *
		 * frappe's own WebFormList constructor does `Object.assign(this, opts)`
		 * before `frappe.web_form_list = this`, so by the time claim_web_form_list
		 * hands us the instance, `instance.doctype` is already set - straight from
		 * the server's own web_form_doc.doc_type. Whatever the route is called,
		 * the list knows what it lists. See take_over() below. */
		var doctype = null;
		var section = null;
		var url = null;

		/* Before anything can fail. The frappe.defaults shim is normally
		 * installed further down, by install_shims() off the back of
		 * load_meta() - fine on the happy path, because the refresh gate holds
		 * every render until then. It is not fine on the fallback path:
		 * restore_stock_list() exists to hand a broken init back to frappe's
		 * own list, and that hand-back rendered rows with no shim in place, so
		 * a Currency column (Grand Total on /my-orders/list and
		 * /my-billing/list) took the whole list down with
		 * "Cannot read properties of undefined (reading 'get_default')" -
		 * frappe.format -> formatters.Currency -> get_field_precision ->
		 * frappe.defaults, which is in no website bundle. See
		 * install_defaults_shim() for the full account. Installing it here
		 * costs nothing and makes the fallback actually be a fallback. */
		if (window.frappe) install_defaults_shim();

		/* Before anything else: web_list.html ships an empty `.web-list-table`,
		 * and nothing fills it until the components, the meta and the list call
		 * have all come back. Paint the placeholder into it the moment it is in
		 * the DOM, so the wait is never a blank card. The column count comes
		 * from the Web Form's own list_columns, which the page's inline script
		 * has by then, so this first placeholder already has the right shape. */
		wait_for(
			function () {
				// frappe.web_form_doc is assigned by the page's own inline script,
				// which the browser reaches a moment after this file; waiting for
				// it is what lets the first placeholder already carry the real
				// column count, so the table does not change width when the rows
				// arrive. web_list.html always sends list_columns - the server
				// fills them in from the doctype when the Web Form declares none.
				return window.$ && window.frappe && frappe.web_form_doc && $(".web-list-table").length;
			},
			function () {
				// Only for a list this app actually serves: a client's own Web
				// Form list must be left looking exactly as frappe renders it.
				if (!PORTAL_SECTIONS[frappe.web_form_doc.doc_type]) return;
				var list_columns = frappe.web_form_doc.list_columns || [];
				render_skeleton($(".web-list-table"), list_columns.length ? list_columns.length + 2 : 0);
			}
		);

		var the_list = null;
		var state = { total: null, page_length: 20, ready: false, restored: false, watchdog: null };
		var ctl = null; // {filter_group, filter_x_button, sort_selector}
		var stock = {}; // the instance methods replaced below, for restore_stock_list()

		function collect_filters() {
			var out = [];
			if (ctl && ctl.filter_group) {
				try { out = ctl.filter_group.get_filters() || []; } catch (e) { log(e, "get_filters"); }
			}
			// Everything currently applied: the desk filter rows plus whatever the
			// web form's own quick filter inputs hold. Both are ANDed, which is
			// what the desk does when a quick filter and a filter row target the
			// same field.
			((the_list && the_list.filter_input) || []).forEach(function (input) {
				var df = input.df || {};
				if (!df.fieldname) return;
				var value = input.get_value ? input.get_value() : null;
				// Falsy means "not filtering", the same rule frappe's own
				// WebFormList.add_filter applies to these very inputs
				// (`if (!value) delete this.filters[field]`). It matters for a
				// **Check** quick filter, whose get_value() returns 0 when the box
				// is clear: keeping that produced a real `field = 0` condition the
				// user never asked for, and an unticked box cannot express "= 0"
				// anyway - there is no third state to mean "no filter" with. The
				// tasks form's Is Milestone box did exactly this and emptied
				// /tasks/list; the field no longer offers a filter at all (the
				// portal-tasks Web Form ships it with show_in_filter off), but any
				// other Check a portal list exposes would have done the same.
				if (!value) return;
				var already = out.some(function (f) { return f[1] === df.fieldname; });
				if (already) return;
				var operator = ["Data", "Small Text", "Text", "Text Editor", "Long Text"].indexOf(df.fieldtype) !== -1
					? "like" : "=";
				out.push([doctype, df.fieldname, operator, operator === "like" ? "%" + value + "%" : value]);
			});
			return out;
		}

		function apply_and_refresh() {
			var filters = collect_filters();
			url.write(filters);
			if (ctl) sync_clear_button(ctl.filter_group, ctl.filter_x_button);
			the_list.web_list_start = 0;
			the_list.refresh();
		}

		function update_count() {
			var shown = document.querySelectorAll(".web-list-container .web-list-table tbody tr").length;
			update_count_text($(".portal-list-count"), shown, state.total);
		}

		/* Swap only the fetch. make_table / append_rows / more() / open_form and
		 * the delete flow are untouched and keep working on the same
		 * {message:[rows]} contract. */
		function install_fetch() {
			stock.fetch_data = the_list.fetch_data;
			the_list.fetch_data = function () {
				var self = this;
				var args = {
					doctype: doctype,
					filters: collect_filters(),
					order_by: url.sort_by + " " + url.sort_order,
					limit_start: self.web_list_start,
					limit: state.page_length,
					web_form_name: self.web_form_name,
				};

				/* frappe's own identical-args-within-3-seconds throttle, reused off
				 * the instance rather than reimplemented - the stock fetch_data
				 * applies it too, so keeping it means no stock behaviour is lost in
				 * the swap. Its job here is the one refresh this file cannot
				 * schedule: make_filters() fires its own when the
				 * get_web_form_filters round trip resolves, and in the rare case
				 * that lands AFTER the toolbar is mounted (so the gate below no
				 * longer holds it) this collapses it into the call already made
				 * instead of repeating it. Same contract as stock: a throttled
				 * call resolves undefined, get_data() then leaves this.data alone
				 * and make_table() re-renders what is already there. */
				if (self.no_change({ method: LIST_METHOD, args: args })) {
					return Promise.resolve();
				}

				/* Only for a first page, and only over a real table: "Load More"
				 * appends into the table already on screen, so replacing it with
				 * a placeholder would drop the rows the user is reading and
				 * leave append_rows writing into a detached tbody. */
				var $wrap = $(".web-list-table");
				if (!self.web_list_start && !has_skeleton($wrap)) {
					render_skeleton($wrap, (self.columns || []).length + 2);
				}

				return fetch_list(args)
					.then(function (payload) {
						state.total = payload.total;
						// covers the empty result, where append_rows never runs
						setTimeout(update_count, 0);
						return { message: payload.rows };
					})
					.catch(function (e) {
						log(e, "fetch");
						// make_table still runs and clears it, but not if the
						// list never gets that far.
						clear_skeleton($(".web-list-table"));
						return { message: [] };
					});
			};
			// keep the list's own paging in step with the page-size control
			the_list.page_length = state.page_length;
		}

		/* Hold every refresh until the Filter/Sort toolbar exists and the URL's
		 * own filters have been read into it.
		 *
		 * WebFormList refreshes itself once on its own timer - the tail of
		 * make_filters()'s get_web_form_filters round trip - fully independent of
		 * this file. Left alone it fires while the toolbar is still being built,
		 * so the FIRST page load went out with none of the filter or sort
		 * arguments the URL asked for and had to be corrected by a second
		 * request a moment later. Gating it is what keeps the page to a single
		 * list request, and it also removes a first paint of unfiltered rows on
		 * any URL that carries filters. Only the initial window is gated: once mount() opens it,
		 * refresh() behaves exactly as frappe wrote it (delete_rows, the web
		 * form's own quick filters, this file's own calls). */
		function install_refresh_gate() {
			stock.refresh = the_list.refresh;
			var original_refresh = the_list.refresh.bind(the_list);
			the_list.refresh = function () {
				if (!state.ready) return;
				return original_refresh();
			};
		}

		/* Three independent bugs traced to the same root cause: the stock
		 * WebFormList triggers its OWN refresh() once, on its own timer
		 * (make_filters()'s `get_web_form_filters` round-trip resolving), fully
		 * independent of this file's own refresh() call below. Patching
		 * refresh/create_more/setup_empty_state - not adding a second, competing
		 * refresh trigger - is what makes the two coexist safely regardless of
		 * which one the network finishes first. Installed from mount(), so a
		 * failed init leaves a completely untouched list behind. */
		function guard_list() {
			if (the_list.__portal_guarded) return;
			the_list.__portal_guarded = true;

			// BUG: "No <doctype> found" rendered twice.
			// make_table_body()'s empty-data branch checks `.no-result` BEFORE an
			// async frappe.has_permission() call, then appends inside that call's
			// callback. Two overlapping refresh() cycles (the stock one above,
			// racing this file's own) can both pass that check before either has
			// actually appended anything - each has_permission() callback then
			// appends its own copy. setup_empty_state() is the actual append; a
			// synchronous re-check immediately before it closes the race, no
			// matter how many callbacks arrive or in what order.
			var original_setup_empty_state = the_list.setup_empty_state.bind(the_list);
			the_list.setup_empty_state = function () {
				if (this.wrapper.find(".no-result").length) return;
				original_setup_empty_state();
			};

			// BUG: page-length buttons ignored by "Load More"'s own show/hide
			// check. refresh() unconditionally resets `this.page_length = 10` on
			// every call (frappe's own code, not this file's), and create_more()
			// - the last step of that same refresh - decides whether to render
			// "Load More" by comparing the fetched row count against that reset
			// value, not the page size actually selected in the footer.
			var original_create_more = the_list.create_more.bind(the_list);
			the_list.create_more = function () {
				this.page_length = state.page_length;
				original_create_more();
			};

			// The count has to be taken after the table is populated; append_rows
			// is the point the list itself finishes rendering them.
			var original_append = the_list.append_rows.bind(the_list);
			the_list.append_rows = function (rows) {
				original_append(rows);
				// Status cells become pills here rather than inside a replaced
				// WebFormListRow: frappe's row class is what owns the checkbox,
				// the row click and the delete selection, and none of that
				// should be re-implemented to change one cell. append_rows is
				// the one point at which every row - the first page and every
				// "Load More" page - has just been built.
				paint_list_status_pills(the_list, doctype);
				// the table is attached to the DOM just after this returns
				setTimeout(update_count, 0);
			};

			// BUG: a filter that matches nothing read "4 of 0" - the old row
			// count against the new total. append_rows never runs for an empty
			// result, so the only count left was the one taken when the fetch
			// resolved, which is a tick before make_table_body() empties the
			// wrapper. make_table is the one point that has run in both cases by
			// the time the table matches the data.
			/* frappe's own empty state, on a list whose user holds no create
			 * DocPerm - which on this portal is nearly all of them.
			 *
			 * WebFormList.make_table_body() renders the "No X found" panel from
			 * inside a `frappe.has_permission(doctype, "", "create", callback)`
			 * probe, and for a portal Customer that callback simply never fires:
			 * they hold no DocPerm at all on Sales Order, Sales Invoice,
			 * Quotation, Project or CRM Deal - those rows reach the page because
			 * portal/scoping.py pins them to the user, not because DocPerm says
			 * so. So an empty section rendered an empty card: no icon, no
			 * message, nothing to say whether it had finished loading. Same
			 * reasoning as ensure_list_read_perm() above.
			 *
			 * The probe's actual purpose is the "Create a new ..." button inside
			 * the panel, and that question already has an answer on the page:
			 * frappe renders a New button in the list header for a form that may
			 * create (allow_multiple), and none for one that may not. So the
			 * panel is rendered unconditionally and its button is kept only when
			 * that header button exists - /inquiry/list and /tasks/list keep it,
			 * /my-orders/list and /my-billing/list do not.
			 *
			 * Wrapping the method rather than calling it directly is what keeps
			 * frappe's own async callback path - which does fire on /issues/list,
			 * where the Customer role really does hold create - from appending a
			 * second panel underneath this one. */
			var original_empty_state = the_list.setup_empty_state.bind(the_list);
			the_list.setup_empty_state = function () {
				if (this.wrapper.find(".no-result").length) return;
				original_empty_state();
				var $panel = this.wrapper.find(".no-result");
				if (!$(".web-list-actions .button-new").length) {
					$panel.find(".btn-new-doc").remove();
				} else if (section.new_label) {
					// The same relabel the header button gets at mount, so the
					// two ways into the form do not read differently.
					$panel.find(".btn-new-doc").text(__(section.new_label));
				}
				// frappe writes the raw doctype name into the message. See
				// doc_label in PORTAL_SECTIONS.
				if (section.doc_label) {
					$panel.find("p").first().text(__("No {0} found", [__(section.doc_label)]));
				}
			};

			var original_make_table = the_list.make_table.bind(the_list);
			the_list.make_table = function () {
				// make_table_body() empties the wrapper in both its branches, so
				// the placeholder goes with it; this only covers the one branch
				// that can return early (a .no-result already rendered).
				clear_skeleton(this.wrapper);
				original_make_table();
				// After original_make_table(), so this only ever fills a gap the
				// permission probe left: a wrapper with no rows and no panel.
				if (!this.wrapper.find("tbody tr").length) this.setup_empty_state();
				setTimeout(update_count, 0);
			};
		}

		/* Anything that stops the toolbar from mounting - a failing asset, a
		 * failing get_meta, a browser that refuses the property claim - must hand
		 * the page back to frappe's own list rather than leave it sitting behind
		 * a gate that will never open. That is the one way this file could end up
		 * worse than not being loaded at all, so it is also on a watchdog. */
		function restore_stock_list() {
			if (!the_list || state.restored) return;
			state.restored = true;
			clearTimeout(state.watchdog);
			if (stock.fetch_data) the_list.fetch_data = stock.fetch_data;
			if (stock.refresh) the_list.refresh = stock.refresh;
			// Two pieces of state the stock list assumes its own refresh cycle
			// established and which a half-finished takeover may have left
			// unset. `data` is the important one: make_table_body() reads
			// `this.data.length` with no guard, so a hand-back whose fetch does
			// not produce rows throws a TypeError and leaves an empty card
			// instead of the list this function exists to restore. `last_args`
			// is the identical-args throttle, cleared so the restoring refresh
			// is never the one that gets collapsed into a call made before it.
			the_list.data = the_list.data || [];
			the_list.last_args = null;
			// back to frappe's own page size, so the create_more() patch above -
			// which may already be installed if mount() failed part way - keeps
			// agreeing with the list it is now guarding
			state.page_length = 10;
			the_list.page_length = 10;
			the_list.web_list_start = 0;
			the_list.refresh();
		}

		/* Runs inside the WebFormList constructor (see claim_web_form_list),
		 * before make_actions()/make_filters() and before `this.wrapper` is even
		 * assigned - so nothing here may touch the DOM or the instance's own
		 * state beyond the two methods it replaces. */
		function take_over(instance) {
			// The one question this whole integration turns on, answered from the
			// instance rather than from the URL. A Web Form list over a doctype
			// this app does not serve is left completely alone - not gated, not
			// wrapped, not restored: untouched.
			doctype = instance.doctype;
			section = PORTAL_SECTIONS[doctype];
			if (!section) return false;
			if (section.gallery) {
				// /videos/list. Reached from here rather than from the dispatch
				// so it is chosen by doctype like every other section, and so it
				// runs inside the constructor - before make_actions()/
				// make_filters() have rendered anything for it to hide.
				init_video_gallery();
				return false;
			}

			the_list = instance;
			url = make_url_codec(doctype, window.location.pathname.replace(/\/+$/, ""), "modified", "desc");
			// Before make_filters() builds the quick filters - it is called two
			// statements after the assignment that brought us here, and on
			// /issues/list two of those filters are Link fields whose real
			// control 403s. See install_link_fallback().
			install_link_fallback();
			install_fetch();
			install_refresh_gate();
			state.watchdog = setTimeout(function () {
				if (!state.ready) restore_stock_list();
			}, WEB_FORM_MOUNT_TIMEOUT);
			return true;
		}

		function mount() {
			if (state.restored) return; // watchdog got there first
			clearTimeout(state.watchdog);

			var $toolbar = $(".web-list-filters");
			$toolbar.removeClass("hide");
			// Before the group is built, so the group is never adopted into it.
			build_quick_area($toolbar);
			var ui = build_controls_block($toolbar);

			// See PORTAL_SECTIONS. Text only - the button, its href and its
			// styling are frappe's, and stay frappe's.
			if (section.new_label) {
				$(".web-list-actions .button-new").text(__(section.new_label));
			}

			ctl = mount_filter_sort(doctype, ui, url, apply_and_refresh);

			build_page_length($(".web-list-footer"), state.page_length, function (n) {
				state.page_length = n;
				the_list.page_length = n;
				the_list.web_list_start = 0;
				the_list.refresh();
			});

			guard_list();

			// The web form's own quick filters call refresh() themselves; make
			// sure the URL keeps up with them too.
			$toolbar.on("change", ".frappe-control input, .frappe-control select", function () {
				setTimeout(function () { url.write(collect_filters()); }, 50);
			});

			// Gate open. This is the page's one and only list request, and it
			// carries the filters and sort the URL asked for.
			state.ready = true;
			the_list.web_list_start = 0;
			the_list.refresh();
		}

		/* Rejects - deliberately, and quietly - for a Web Form list this app does
		 * not serve. A client's own form reaching this file is the expected case
		 * on a bench that has other Web Forms, not a fault, so NOT_OURS is
		 * swallowed rather than logged; every other failure still is. */
		var NOT_OURS = "not a portal section";
		var claimed = new Promise(function (resolve, reject) {
			claim_web_form_list(function (instance) {
				if (take_over(instance)) resolve(instance);
				else reject(new Error(NOT_OURS));
			});
		});
		// A rejection that nothing is attached to yet is an unhandled rejection
		// in the console; the real handling is in the chain below.
		claimed.catch(function () {});

		wait_for(
			function () {
				return (
					window.frappe && frappe.ui && frappe.ui.form &&
					frappe.model && frappe.meta && window.$
				);
			},
			function () {
				// Started before the claim resolves, and deliberately: it needs no
				// doctype, and the WebFormList is not constructed until
				// web_form.bundle.js has loaded and frappe.ready has fired. Only
				// load_meta() has to wait, because only load_meta() needs to know
				// what the list lists.
				var components = load_components();

				claimed
					.then(function () { return components; })
					.then(await_components)
					.then(function () { return load_meta(doctype); })
					.then(mount)
					.catch(function (e) {
						if (e && e.message === NOT_OURS) return;
						// Leave the stock list working rather than half-upgrading it.
						log(e, "init web form list");
						restore_stock_list();
					});
			}
		);
	}

	// =============================================================================
	// Plain portal list routes: /orders (Sales Order), /invoices (Sales
	// Invoice), /project (Project)
	//
	// Unlike the Web Form routes, there is no reusable list object here - the
	// stock page (frappe/www/list.html + templates/includes/list/list.js) is
	// server-rendered HTML fragments with inline Jinja-templated pagination JS.
	// This owns the list end to end: quick filters, Filter/Sort toolbar, table,
	// paging - inside the page's existing .page_content card, replacing what it
	// currently renders there.
	//
	// Nothing below is written per route. The quick filters come from the
	// doctype's own in_standard_filter fields (get_standard_filter_fields), the
	// columns from its title_field / in_list_view fields
	// (get_list_view_columns), the status pill from INDICATORS, and every cell
	// through frappe.format - so adding a route is one PORTAL_LIST_ROUTES entry
	// plus the matching server-side scope in portal/scoping.py.
	// =============================================================================

	/* Which fields the desk shows as always-visible quick filters, and how it
	 * maps each one to a control - ported from frappe.list.BaseList's own
	 * make_standard_filters() (frappe/public/js/frappe/list/base_list.js) so
	 * the portal shows exactly the same fields in exactly the same order: ID
	 * first, then every DocField that is either the title_field or has
	 * in_standard_filter set, in DocType field-declaration order. On Sales
	 * Invoice that is ID, Title, Customer, Company, Status - the same five
	 * /app/sales-invoice puts above its own list.
	 *
	 * Deliberately dropped from the original: the frappe.perm.has_perm() gate
	 * that decides whether a field is visible at all. That check answers "does
	 * this user have ordinary DocPerm read on this field", which is the wrong
	 * question here - Sales Order rows reach this page at all only because
	 * portal/scoping.py pins them to the user's own Customer and queries with
	 * ignore_permissions=True (mirroring erpnext's own get_transaction_list);
	 * a portal Customer typically holds no DocPerm read on Sales Order or
	 * Sales Invoice in the first place, so applying that gate would hide every
	 * quick filter. */
	function get_standard_filter_fields(doctype) {
		var meta = frappe.get_meta(doctype);
		var title_field = meta.title_field;
		var TEXT_LIKE = [
			"Text", "Small Text", "Text Editor", "HTML Editor", "Markdown Editor",
			"Data", "Code", "Phone", "JSON", "Read Only",
		];

		var fields = [{ fieldtype: "Data", label: "ID", fieldname: "name", condition: "like" }];

		(meta.fields || []).forEach(function (df) {
			var qualifies = df.fieldname === title_field ||
				(df.in_standard_filter && frappe.model.is_value_type(df.fieldtype));
			if (!qualifies) return;

			var fieldtype = df.fieldtype;
			var condition = "=";
			var options = df.options;

			if (TEXT_LIKE.indexOf(fieldtype) !== -1) {
				fieldtype = "Data";
				condition = "like";
			}
			if (fieldtype === "Select" && options) {
				var opts = options.split("\n");
				if (opts.length > 0 && opts[0] !== "") {
					opts.unshift("");
					options = opts.join("\n");
				}
			}

			fields.push({
				fieldtype: fieldtype,
				label: df.label,
				options: options,
				fieldname: df.fieldname,
				condition: condition,
			});
		});

		return fields;
	}

	/* erpnext's own status-computation logic for the Sales Order list, ported
	 * verbatim from frappe.listview_settings["Sales Order"].get_indicator in
	 * erpnext/selling/doctype/sales_order/sales_order_list.js (not
	 * independently fetchable: it is a doctype_list_js file, bundled into the
	 * desk's erpnext.bundle.js at build time rather than served as a static
	 * asset, and that bundle is not loaded on the website). Copied rather than
	 * re-derived so the portal's status pills can never silently drift from
	 * what the desk actually shows for the same order. Re-sync this if erpnext
	 * changes that function. flt / frappe.datetime.get_diff are both already
	 * in frappe-web.bundle.js, which every website page loads. */
	function sales_order_indicator(doc) {
		if (doc.status === "Closed") return [__("Closed"), "green"];
		if (doc.status === "On Hold") return [__("On Hold"), "orange"];
		if (doc.status === "Completed") return [__("Completed"), "green"];

		if (!doc.skip_delivery_note && flt(doc.per_delivered) < 100) {
			if (frappe.datetime.get_diff(doc.delivery_date) < 0) {
				return [__("Overdue"), "red"];
			}
			if (flt(doc.grand_total) === 0) {
				return [__("To Deliver"), "orange"];
			}
			if (flt(doc.per_billed) < 100) {
				return [__("To Deliver and Bill"), "orange"];
			}
			return [__("To Deliver"), "orange"];
		}
		if (flt(doc.per_delivered) === 100 && flt(doc.grand_total) !== 0 && flt(doc.per_billed) < 100) {
			return [__("To Bill"), "orange"];
		}
		if (doc.skip_delivery_note && flt(doc.per_billed) < 100) {
			return [__("To Bill"), "orange"];
		}
		return [__(doc.status), "gray"];
	}

	/* The same thing for the Sales Invoice list, ported verbatim from
	 * frappe.listview_settings["Sales Invoice"].get_indicator in
	 * erpnext/accounts/doctype/sales_invoice/sales_invoice_list.js - not
	 * fetchable at runtime for the same reason as the Sales Order one above
	 * (a doctype_list_js file, bundled into the desk's erpnext.bundle.js at
	 * build time and never served as a static asset). Unlike Sales Order's,
	 * this one is a flat status -> colour map with no computation in it at
	 * all, so /invoices shows exactly the pill /app/sales-invoice shows for
	 * the same document. Re-sync this if erpnext changes that map.
	 *
	 * The `|| "gray"` is this file's own: erpnext's map has no entry for
	 * "Submitted", "Cancelled" or "Overdue and Discounted" (all reachable
	 * Sales Invoice statuses), and the desk renders those with no colour class
	 * at all. A pill with no colour is invisible against the row, so they get
	 * the same neutral grey the Sales Order function above already falls back
	 * to for a status it does not recognise. */
	function sales_invoice_indicator(doc) {
		var status_colors = {
			Draft: "red",
			Unpaid: "orange",
			Paid: "green",
			Return: "gray",
			"Credit Note Issued": "gray",
			"Unpaid and Discounted": "orange",
			"Partly Paid and Discounted": "yellow",
			"Overdue and Discounted": "red",
			Overdue: "red",
			"Partly Paid": "yellow",
			"Internal Transfer": "darkgrey",
		};
		return [__(doc.status), status_colors[doc.status] || "gray"];
	}

	/* And for the Project list, ported verbatim from
	 * frappe.listview_settings["Project"].get_indicator in
	 * erpnext/projects/doctype/project/project_list.js - a doctype_list_js
	 * file, so not fetchable at runtime for the same reason as the two above.
	 * Re-sync this if erpnext changes that function.
	 *
	 * The third element of erpnext's returned array is the desk's
	 * click-to-filter argument ("status,=,Open"); it is dropped here because
	 * render_cell() reads only the label and the colour, exactly as it already
	 * does for the two functions above.
	 *
	 * frappe.utils.guess_colour is part of frappe-web.bundle.js, which every
	 * website page loads, so the fallback branch works here unchanged. */
	function project_indicator(doc) {
		/* One deliberate divergence from erpnext's own function, and the only
		 * one in this file: its first branch returns the *percentage* as the
		 * pill label for an Open project with any progress at all
		 * ("33%", orange) instead of the status. In the desk that is a
		 * shorthand, because the desk's Project list has no % Completed column
		 * to collide with. The portal's does - and its record page carries a
		 * Progress bar as well (render_project_panel) - so the shorthand read
		 * as the same number printed twice on the list and three times on the
		 * detail page, with the actual status ("Open") shown nowhere at all.
		 * The Status pill states the status; percent belongs to the column and
		 * the bar that are labelled for it. */
		if (doc.status === "On hold") {
			return [__("On hold"), "blue"];
		} else {
			return [__(doc.status), frappe.utils.guess_colour(doc.status)];
		}
	}

	/* And for the Quotation list, ported verbatim from
	 * frappe.listview_settings["Quotation"].get_indicator in
	 * erpnext/selling/doctype/quotation/quotation_list.js - a doctype_list_js
	 * file, so not fetchable at runtime for the same reason as the others.
	 * Re-sync this if erpnext changes that function.
	 *
	 * The `|| "gray"` tail is this file's own, for the same reason it is on
	 * sales_invoice_indicator above: erpnext's chain has no branch for "Draft"
	 * or "Cancelled", and returning undefined would render no pill at all.
	 * Draft matters more here than it does elsewhere, because the portal's
	 * "Request a Quotation" page creates exactly that - see
	 * PORTAL_DRAFTS_VISIBLE in overrides/portal_list_utils.py for why those
	 * rows are in the list in the first place. */
	function quotation_indicator(doc) {
		var status_colors = {
			Open: "orange",
			"Partially Ordered": "yellow",
			Ordered: "green",
			Lost: "gray",
			Expired: "gray",
		};
		return [__(doc.status), status_colors[doc.status] || "gray"];
	}

	/* And for the Task list, ported verbatim from
	 * frappe.listview_settings["Task"].get_indicator in
	 * erpnext/projects/doctype/task/task_list.js - a doctype_list_js file, so
	 * not fetchable at runtime for the same reason as the others. Re-sync this
	 * if erpnext changes that map.
	 *
	 * Note "Cancelled" really is "dark grey" with a space upstream. That is not
	 * a class frappe's indicator.scss defines ($indicator-colors has
	 * `darkgrey`); the desk only renders it because the space splits it into
	 * two classes and the second one, `grey`, happens to be defined. The colour
	 * is passed through unchanged here and normalised once, for every
	 * indicator, in status_pill_html() below - so this stays a verbatim port
	 * and the fix lives in one place. */
	function task_indicator(doc) {
		var colors = {
			Open: "orange",
			Overdue: "red",
			"Pending Review": "orange",
			Working: "orange",
			Completed: "green",
			Cancelled: "dark grey",
			Template: "blue",
		};
		return [__(doc.status), colors[doc.status]];
	}

	/* And for the Issue list, ported verbatim from
	 * frappe.listview_settings["Issue"].get_indicator in
	 * erpnext/support/doctype/issue/issue_list.js. The one branch that is not a
	 * flat map: an open Issue is coloured by its *priority*, not its status, so
	 * a High-priority open ticket reads red and a Low one yellow - exactly as
	 * it does in the desk. Issue.priority is a Link to Issue Priority, and the
	 * three names erpnext ships are the three keys below; any other priority
	 * falls back to red, which is upstream's own fallback, not this file's. */
	function issue_indicator(doc) {
		if (doc.status === "Open") {
			var color = { Low: "yellow", Medium: "orange", High: "red" };
			return [__(doc.status), color[doc.priority] || "red"];
		}
		if (doc.status === "Closed") return [__(doc.status), "green"];
		return [__(doc.status), "gray"];
	}

	/* And for the portal's Inquiry list - CRM Deal, from the `crm` app. Not a
	 * port of anything: CRM's front end is a Vue app with no listview_settings
	 * and no get_indicator to copy, and its stage colours are configuration
	 * (CRM Deal Status rows), not source. So the label is the stage name and the
	 * colour is that row's own `color`, fetched into STATUS_COLORS above.
	 *
	 * The gray fallback covers the window before that fetch resolves and a
	 * bench where the colour column is empty - the same neutral pill every
	 * other indicator here falls back to, rather than an unstyled and therefore
	 * invisible one. */
	function crm_deal_indicator(doc) {
		var colors = STATUS_COLORS["CRM Deal"] || {};
		return [__(doc.status), colors[doc.status] || "gray"];
	}

	/* Which portal lists have a Status column, and what computes it. This is
	 * the portal's answer to the desk's own frappe.has_indicator(doctype),
	 * which reads frappe.listview_settings - built into the desk bundle, not
	 * loaded here. A doctype absent from this map simply has no Status column,
	 * exactly as the desk drops one for a doctype with no get_indicator.
	 *
	 * Task and Issue have no *plain* portal list route of their own (they are
	 * Web Form lists), so they add no column to get_list_view_columns; they are
	 * here because the same map is what colours the Status cell on the Web Form
	 * list routes and the Status field on every record page. One map, one set
	 * of colours, every section that shows a status. */
	var INDICATORS = {
		"Sales Order": sales_order_indicator,
		"Sales Invoice": sales_invoice_indicator,
		Project: project_indicator,
		Quotation: quotation_indicator,
		Task: task_indicator,
		Issue: issue_indicator,
		"CRM Deal": crm_deal_indicator,
	};

	/* One status pill, in frappe's own indicator markup, for any doctype in
	 * INDICATORS. Everything that shows a status goes through this: the plain
	 * portal list cells, the Web Form list cells, and the Status field on a
	 * record page.
	 *
	 * The colour is normalised to the class names indicator.scss actually
	 * defines (green, cyan, blue, orange, yellow, gray, grey, red, pink,
	 * darkgrey, purple, light-blue): lower-cased, and inner whitespace removed
	 * so erpnext's "dark grey" resolves to the real `darkgrey` class instead of
	 * relying on the space splitting it into two. An unrecognised colour falls
	 * back to gray rather than rendering an unstyled - and therefore invisible
	 * - pill. */
	/* Status pill colours that are site *configuration* rather than code, keyed
	 * by doctype: `{ "CRM Deal": { Qualification: "gray", Won: "green", ... } }`.
	 *
	 * Every other indicator below is a hand-ported copy of a `<doctype>_list.js`
	 * get_indicator, because erpnext writes those maps in source and bundles
	 * them into the desk's own erpnext.bundle.js, where the website cannot reach
	 * them. CRM's are not in source at all: a deal's stages and their colours
	 * are rows in `CRM Deal Status`, renamed and recoloured from the CRM UI. So
	 * they are read on the server (list_api.STATUS_COLOR_TABLES) and ride back
	 * on the two endpoints a portal page already calls - get_meta for a list,
	 * get_currency_docs for a record - rather than being frozen into this file.
	 *
	 * Filled before the first row is rendered on a list page (load_meta resolves
	 * before mount), and possibly *after* the first paint on a record page,
	 * which is why set_status_colors() repaints. */
	var STATUS_COLORS = {};

	// Set by paint_record_status() on a record page, so a colour map arriving
	// after the first paint can be applied to the pill already on screen.
	var repaint_record_status = null;

	function set_status_colors(doctype, colors) {
		if (!doctype || !colors || !Object.keys(colors).length) return;
		STATUS_COLORS[doctype] = colors;
		if (repaint_record_status) repaint_record_status(true);
	}

	var PILL_COLORS = [
		"green", "cyan", "blue", "orange", "yellow", "gray", "grey",
		"red", "pink", "darkgrey", "purple", "light-blue",
	];

	function pill_color(color) {
		var normalised = String(color || "").toLowerCase().replace(/\s+/g, "");
		return PILL_COLORS.indexOf(normalised) !== -1 ? normalised : "gray";
	}

	/* The portal's submittable doctypes, for the draft/cancelled check below.
	 *
	 * The desk asks frappe.model.is_submittable(), which reads
	 * frappe.get_meta(doctype).is_submittable. That is answerable on a portal
	 * *list* route, where load_meta() has just synced the meta, and not on a
	 * record route, where nothing loads a meta at all - so it is listed rather
	 * than derived, for the same reason INDICATORS is. Every entry is a doctype
	 * this file already names in PORTAL_SECTIONS or PORTAL_LIST_ROUTES; the
	 * others (Task, Issue, Project, CRM Deal) are not submittable and must not
	 * be here, or every one of their rows would read "Draft". */
	var SUBMITTABLE = { "Sales Order": 1, "Sales Invoice": 1, Quotation: 1 };

	/* Draft and Cancelled, ahead of any doctype-specific indicator.
	 *
	 * This is the step frappe's own frappe.get_indicator() takes before it
	 * consults listview_settings[doctype].get_indicator
	 * (frappe/public/js/frappe/model/indicator.js: "draft if document is
	 * submittable"), and the INDICATORS ports below deliberately do not contain
	 * it - erpnext's functions do not either, because in the desk they are never
	 * reached for a draft.
	 *
	 * Without it a draft Sales Order was labelled by the delivery branch of
	 * erpnext's function: an unsubmitted order with a past delivery date read
	 * "Overdue" in red, and one without read "To Deliver" - both describing work
	 * on a document nobody has confirmed yet. That only became visible when
	 * drafts entered the list at all (see PORTAL_DRAFTS_VISIBLE in
	 * overrides/portal_list_utils.py); a draft Quotation, already listed, had
	 * the milder version of the same bug, showing frappe's grey fallback where
	 * the desk shows red. */
	function submitted_state_pill(doctype, doc) {
		if (!SUBMITTABLE[doctype] || !doc) return null;
		var docstatus = cint(doc.docstatus);
		if (docstatus === 0) return [__("Draft"), "red"];
		if (docstatus === 2) return [__("Cancelled"), "red"];
		return null;
	}

	function status_pill_html(doctype, doc) {
		var indicator = INDICATORS[doctype];
		var pair =
			submitted_state_pill(doctype, doc) ||
			(indicator ? indicator(doc) : [doc && doc.status, "gray"]);
		if (!pair || !pair[0]) return "";
		return (
			'<span class="indicator-pill ' + pill_color(pair[1]) + '"><span>' +
			frappe.utils.escape_html(pair[0]) +
			"</span></span>"
		);
	}

	/* Columns whose fieldnames are NOT in the list here are dropped after the
	 * desk derivation below has run. There is one entry, and it exists purely
	 * to hold /orders still: that page shipped with a hand-written four-column
	 * set, and deriving its columns from meta the way the desk does would have
	 * silently added Grand Total, % Delivered and % Billed to a list people
	 * already use. Every column named here is one the derivation produces
	 * anyway, in this same order - this only subtracts, so /orders keeps the
	 * labels, formatting and ordering it has always had. A doctype with no
	 * entry (Sales Invoice, Project) shows exactly what the desk shows. */
	var COLUMN_WHITELIST = {
		"Sales Order": ["customer_name", "status", "delivery_date", "name"],
	};

	/* Which columns the desk's List View shows for a doctype and in what
	 * order, ported from frappe.views.ListView's own setup_columns()
	 * (frappe/public/js/frappe/list/list_view.js) rather than hand-listed, so
	 * a portal list covers exactly the columns /app/<doctype> covers and can
	 * never drift from the doctype's own title_field / in_list_view settings.
	 *
	 * Three deliberate differences from the original, none of them changing
	 * which columns come out:
	 *
	 *   - The Tag column is built and counted against the total_fields budget
	 *     exactly as the desk counts it, then dropped before rendering.
	 *     Keeping it in the count is what makes the slice below agree with the
	 *     desk column-for-column; rendering it would not, since _user_tags is
	 *     a desk feature the portal has no UI for (and which the desk itself
	 *     ships hidden until tags are switched on).
	 *   - list_view_settings - a per-user desk customisation of column choice
	 *     and count - is not read. There is no portal equivalent to customise,
	 *     so every list gets the doctype's own defaults.
	 *   - frappe.has_indicator() is INDICATORS above, for the reason given
	 *     there.
	 *
	 * The three width breakpoints are the desk's own, so a portal list sheds
	 * and regains columns on a narrow or a wide screen exactly as the desk
	 * list does.
	 */
	function get_list_view_columns(doctype) {
		var meta = frappe.get_meta(doctype);
		// Callers run this only after load_meta(), which throws if the meta is
		// unavailable - so this is belt and braces: a list with no columns is
		// recoverable, a throw out of mount() is not.
		if (!meta) {
			log(new Error("no meta for " + doctype), "columns");
			return [];
		}
		var title_field = meta.title_field;
		var has_indicator = !!INDICATORS[doctype];
		var columns = [];

		// 1st column: title_field or name
		columns.push({
			type: "Subject",
			fieldname: title_field || "name",
			df: title_field
				? frappe.meta.get_docfield(doctype, title_field)
				: { label: __("ID"), fieldname: "name" },
		});

		columns.push({ type: "Tag", fieldname: "_user_tags" });

		// 2nd column: Status indicator
		if (has_indicator) {
			columns.push({ type: "Status", fieldname: "status" });
		}

		// the rest, from the in_list_view docfields
		(meta.fields || []).forEach(function (df) {
			if (!df.in_list_view || df.is_virtual) return;
			if (has_indicator && df.fieldname === "status") return;
			if (df.fieldname === title_field) return;
			columns.push({ type: "Field", fieldname: df.fieldname, df: df });
		});

		// Low-density screen 4 columns, medium 6, high 8 (10 in the source) -
		// frappe's own comment and its own numbers.
		var total_fields = 6;
		if (window.innerWidth <= 1366) {
			total_fields = 4;
		} else if (window.innerWidth >= 1920) {
			total_fields = 10;
		}
		columns = columns.slice(0, total_fields);

		// ID is appended after the slice, so it is never the column that gets
		// cut - the desk does the same.
		if (title_field && title_field !== "name") {
			columns.push({
				type: "Field",
				fieldname: "name",
				df: { label: __("ID"), fieldname: "name" },
			});
		}

		var whitelist = COLUMN_WHITELIST[doctype];
		if (whitelist) {
			columns = columns.filter(function (col) {
				return whitelist.indexOf(col.fieldname) !== -1;
			});
		}

		return columns
			.filter(function (col) {
				return col.type !== "Tag";
			})
			.map(function (col) {
				return {
					type: col.type,
					fieldname: col.fieldname,
					df: col.df,
					// The desk labels a Status column with the column TYPE, not
					// with the status field's own label; everything else with
					// its docfield label (get_header_html).
					label:
						col.type === "Status"
							? __("Status")
							: __((col.df && col.df.label) || col.fieldname),
					// Same test the desk applies to decide `text-right`.
					numeric: !!(col.df && frappe.model.is_numeric_field(col.df)),
				};
			});
	}

	function init_portal_list(doctype, route) {
		var $content = $(".page_content");
		if (!$content.length) return;

		var state = { total: null, page_length: 20, start: 0, rows_shown: 0 };
		var url = make_url_codec(doctype, window.location.pathname.replace(/\/+$/, ""), "modified", "desc");
		var ctl = null;
		var $table_body = null;
		var quick_filter_controls = [];

		/* The desk's own List View column set for this doctype - see
		 * get_list_view_columns(). Filled in by mount(), NOT here: deriving it
		 * reads the doctype's meta, and nothing on a website page has loaded
		 * that yet at this point. load_meta() below is what puts it in
		 * locals.DocType, so anything meta-dependent has to wait for mount().
		 * Reading it here threw a TypeError out of this function synchronously,
		 * which the dispatch's own .catch() then swallowed - leaving the page
		 * showing its original server-rendered card with no toolbar at all. */
		var COLUMNS = [];

		// Bumped on every refresh()/load_more() call; a still-in-flight request
		// whose generation no longer matches discards its result instead of
		// mutating the DOM. Without this, changing a quick filter while a "Load
		// More" request is still in flight can append rows into a table that
		// refresh() has already replaced (or vice versa) - the exact class of
		// overlapping-async-request bug already found and fixed once in
		// init_web_form_list() above, guarded against here from the start.
		var request_id = 0;

		/* Where a row click goes. The default is the convention every portal
		 * transaction list follows - /orders/SAL-ORD-0001 - which erpnext
		 * declares as a website_route_rule per doctype. /project is the
		 * exception: erpnext gives Project no such rule, and its detail view is
		 * a query-string page (erpnext/templates/pages/projects.py, the same
		 * target its own row template links to), so that route brings its own
		 * builder. See PORTAL_LIST_ROUTES. */
		function row_href(doc) {
			if (route && route.detail_href) return route.detail_href(doc);
			return window.location.pathname.replace(/\/+$/, "") + "/" + encodeURIComponent(doc.name);
		}

		/* Everything currently applied: the desk filter rows plus whatever the
		 * quick filter inputs hold - the same ANDed-together pattern
		 * init_web_form_list() uses for the web form's own quick filters. */
		function collect_filters() {
			var out = [];
			if (ctl && ctl.filter_group) {
				try { out = ctl.filter_group.get_filters() || []; } catch (e) { log(e, "get_filters"); }
			}
			quick_filter_controls.forEach(function (entry) {
				var control = entry.control, df = control.df || {};
				if (!df.fieldname) return;
				var value = control.get_value ? control.get_value() : null;
				// Same rule as init_web_form_list()'s collect_filters above.
				if (!value) return;
				var already = out.some(function (f) { return f[1] === df.fieldname; });
				if (already) return;
				var operator = entry.condition || "=";
				out.push([doctype, df.fieldname, operator, operator === "like" ? "%" + value + "%" : value]);
			});
			return out;
		}

		/* One cell, formatted the way the desk formats the same field.
		 *
		 * Everything except the Status pill goes through frappe.format, so a
		 * Currency column picks up the row's own currency symbol and the site
		 * number format, a Date column the site date format, and so on -
		 * rather than each fieldtype needing a branch here. `only_value` asks
		 * for the bare value instead of the desk's own wrapper markup (an
		 * /app/... anchor for a Link, a right-aligned <div> for a number):
		 * the portal row is one big link to the document already, and numeric
		 * columns are aligned through the cell's own class below, the same way
		 * the desk's `text-right` does it.
		 *
		 * The result is escaped, not inserted as markup: with `only_value`
		 * every fieldtype a portal list column can hold formats to a plain
		 * string, so there is nothing here that needs to render as HTML. */
		function render_cell(doc, col) {
			if (col.type === "Status") {
				return status_pill_html(doctype, doc);
			}

			var value = doc[col.fieldname];
			if (value === null || value === undefined || value === "") return "";

			var formatted = value;
			try {
				formatted = frappe.format(value, col.df || { fieldtype: "Data" }, { only_value: 1 }, doc);
			} catch (e) {
				// A formatter that throws must cost one cell's formatting, not
				// the whole list: fall back to the raw value.
				log(e, "format " + col.fieldname);
			}
			return frappe.utils.escape_html(
				formatted === null || formatted === undefined ? "" : String(formatted)
			);
		}

		function render_header() {
			var $thead = $("<thead><tr></tr></thead>");
			var $tr = $thead.find("tr");
			$('<th class="list-col-checkbox"><input type="checkbox" class="select-all"></th>').appendTo($tr);
			$('<th class="list-col-serial">' + __("Sr") + ".</th>").appendTo($tr);
			COLUMNS.forEach(function (col) {
				$("<th></th>")
					.toggleClass("list-col-numeric", col.numeric)
					.text(col.label)
					.appendTo($tr);
			});
			return $thead;
		}

		function render_rows($tbody, rows, start_index) {
			rows.forEach(function (doc, i) {
				var $tr = $('<tr data-name="' + frappe.utils.escape_html(doc.name) + '"></tr>').appendTo($tbody);
				$('<td class="list-col-checkbox"><input type="checkbox"></td>').appendTo($tr);
				$('<td class="list-col-serial"></td>').text(start_index + i + 1).appendTo($tr);
				COLUMNS.forEach(function (col) {
					$("<td><p></p></td>")
						.toggleClass("list-col-numeric", col.numeric)
						.find("p")
						.html(render_cell(doc, col))
						.end()
						.appendTo($tr);
				});
				// Same pattern web_form_list.js's own WebFormListRow uses: the
				// checkbox stops the click from reaching the row handler, rather
				// than the row handler trying to recognise the checkbox.
				$tr.find('input[type="checkbox"]').on("click", function (e) {
					e.stopImmediatePropagation();
				});
				$tr.on("click", function () {
					window.location.href = row_href(doc);
				});
			});
		}

		function render_empty($wrapper) {
			$wrapper.html(
				'<div class="no-result text-muted flex justify-center align-center">' +
					'<div class="text-center">' +
						'<div><img src="/assets/frappe/images/ui-states/list-empty-state.svg" ' +
							'alt="" class="null-state"></div>' +
						'<p class="small mb-2">' + __("No {0} found", [__(doctype)]) + "</p>" +
					"</div>" +
				"</div>"
			);
		}

		function fetch(reset) {
			if (reset) { state.start = 0; state.rows_shown = 0; }
			return fetch_list({
				doctype: doctype,
				filters: collect_filters(),
				order_by: url.sort_by + " " + url.sort_order,
				limit_start: state.start,
				limit: state.page_length,
			})
				.then(function (payload) {
					state.total = payload.total;
					return payload.rows;
				})
				.catch(function (e) {
					log(e, "fetch");
					return [];
				});
		}

		function refresh() {
			var my_id = ++request_id;
			// Replaced below by whichever branch renders; load_more() gets none,
			// since its rows are appended under the ones already on screen.
			render_skeleton($(".web-list-table"), COLUMNS.length + 2);
			return fetch(true).then(function (rows) {
				if (my_id !== request_id) return; // superseded by a later refresh()

				var $table_wrap = $(".web-list-table").removeAttr("aria-busy");
				if (!rows.length) {
					state.rows_shown = 0;
					render_empty($table_wrap);
				} else {
					var $table = $('<table class="table"></table>');
					render_header().appendTo($table);
					$table_body = $("<tbody></tbody>").appendTo($table);
					render_rows($table_body, rows, 0);
					state.rows_shown = rows.length;
					$table_wrap.empty().append($table);
				}
				toggle_load_more();
				update_count_text($(".portal-list-count"), state.rows_shown, state.total);
			});
		}

		function load_more() {
			// Must match the CURRENT generation, not start a new one: a filter
			// or sort change firing while this is in flight means refresh() has
			// already rebuilt the table, and appending here would land in a
			// $table_body that is no longer attached to it.
			var my_id = request_id;
			state.start += state.page_length;
			return fetch(false).then(function (rows) {
				if (my_id !== request_id || !rows.length) return;
				render_rows($table_body, rows, state.rows_shown);
				state.rows_shown += rows.length;
				toggle_load_more();
				update_count_text($(".portal-list-count"), state.rows_shown, state.total);
			});
		}

		function toggle_load_more() {
			var $btn = $(".web-list-footer .more");
			var has_more = state.total !== null && state.total !== undefined && state.rows_shown < state.total;
			$btn.toggleClass("hide", !has_more);
		}

		function apply_and_refresh() {
			url.write(collect_filters());
			if (ctl) sync_clear_button(ctl.filter_group, ctl.filter_x_button);
			refresh();
		}

		/* make_control's own fallback for a fieldtype it has no class for is to
		 * console.log("Invalid Control Name: ...") and return undefined - not
		 * throw. Customer and Company are normally rewritten to Select by
		 * apply_filter_field_overrides(), but that rewrite itself depends on
		 * get_filter_field_overrides() finding this user a scoped customer list
		 * (scoping.py) - for anyone it can't (Administrator or any other
		 * non-website user, exactly like Task/Issue already deny; a website
		 * user with no Portal User link at all) it deliberately returns {},
		 * leaving those two fields as their original, unloaded "Link" fieldtype.
		 * Checking this BEFORE calling make_control - not after, by reading
		 * .wrapper off whatever it returned - is what keeps a user in that
		 * situation looking at a toolbar with two fewer quick filters instead
		 * of a page that throws before ever listing anything. */
		function control_class_available(fieldtype) {
			var name = "Control" + fieldtype.replace(/ /g, "");
			return !!frappe.ui.form[name];
		}

		function mount_quick_filters($parent) {
			var fields = get_standard_filter_fields(doctype).filter(function (df) {
				return control_class_available(df.fieldtype);
			});
			var url_filters_by_field = {};
			url.read().forEach(function (f) { url_filters_by_field[f[1]] = f; });

			fields.forEach(function (df) {
				var control = frappe.ui.form.make_control({
					df: {
						fieldtype: df.fieldtype,
						fieldname: df.fieldname,
						options: df.options,
						input_class: "input-xs",
						only_select: true,
						label: df.label,
						onchange: function () { apply_and_refresh(); },
					},
					parent: $parent,
					render_input: 1,
					only_input: df.fieldtype === "Check" ? false : true,
				});
				if (!control) return; // belt and braces: see control_class_available() above
				// only_input already gives the wrapper class="form-group
				// frappe-control" and data-fieldtype/data-fieldname
				// (base_control.js / base_input.js) - only `title` (read by this
				// app's CSS Select-placeholder trick) needs adding here, the
				// same way web_form_list.js's own make_filters() does it for the
				// quick filters it builds.
				$(control.wrapper).attr("title", df.label);
				if (control.$input) control.$input.attr("placeholder", df.label);

				var seeded = url_filters_by_field[df.fieldname];
				if (seeded && seeded[2] === df.condition) {
					var value = seeded[3];
					if (df.condition === "like" && typeof value === "string") {
						value = value.replace(/^%/, "").replace(/%$/, "");
					}
					control.set_value(value);
				}

				quick_filter_controls.push({ control: control, condition: df.condition });
			});
		}

		function mount() {
			// meta is loaded by now (load_meta below), so the column set can be
			// derived - see the COLUMNS declaration above for why not earlier.
			COLUMNS = get_list_view_columns(doctype);

			$content.empty();

			var $toolbar = $('<div class="web-list-filters"></div>').appendTo($content);
			mount_quick_filters(build_quick_area($toolbar));

			var ui = build_controls_block($toolbar);
			ctl = mount_filter_sort(doctype, ui, url, apply_and_refresh);
			if (route && route.create) build_create_button(ui.controls, route.create);

			$('<div class="web-list-table"></div>').appendTo($content);

			var $footer = $('<div class="web-list-footer"></div>').appendTo($content);
			build_page_length($footer, state.page_length, function (n) {
				state.page_length = n;
				refresh();
			});
			$('<button class="more btn btn-default btn-sm hide" type="button">' + __("Load More") + "</button>")
				.on("click", function () {
					var $btn = $(this).prop("disabled", true);
					load_more().always(function () { $btn.prop("disabled", false); });
				})
				.appendTo($footer);

			// Caught separately from the init chain below: mount() has already
			// succeeded by this point (toolbar and footer are built and in the
			// DOM), so a failure fetching the first page should be logged, not
			// treated as a total init failure that tears the toolbar back down.
			refresh().catch(function (e) { log(e, "refresh"); });
		}

		load_meta(doctype).then(mount).catch(function (e) {
			log(e, "init portal list");
			// Leave *something* usable rather than an empty card.
			$content.find(".web-list-table, .web-list-filters, .web-list-footer").remove();
		});
	}

	// =============================================================================
	// Portal RECORD pages — /<route>/<name>, /<route>/<name>/edit, /<route>/new
	//
	// These pages are frappe's own: web_form.bundle.js builds the form, and
	// nothing below rebuilds any part of it. Five things are added on top:
	//
	//   1. a guard on the "Not Saved" pill, which a read-only portal record page
	//      showed permanently and meaninglessly, plus a snapshot of the document
	//      before the form starts writing into it (claim_web_form);
	//   2. a Select left holding a value it has no option for - which a bad
	//      `?field=` in the URL produces and frappe's own control does not
	//      recover from - put back on its first option (guard_select_defaults);
	//   3. the Status field rendered as the same coloured pill the lists show
	//      (paint_record_status);
	//   4. the currency rows a Currency field needs to print a symbol rather
	//      than a code, which only the list pages were fetching
	//      (load_currency_docs);
	//   5. on a Project, the parts of the desk's Project form a Web Form cannot
	//      express: progress, the Tasks/Issues links, and the activity timeline
	//      (init_project_record).
	//
	// Two fields per line is not here - it is a grid rule in
	// public/css/portal_list.bundle.css, which needs no JS and reaches the one
	// Web Form this app must not edit (erpnext owns `issues`).
	// =============================================================================

	/* A read-only Link field on a Web Form throws on render.
	 *
	 * A Web Form does not use ControlLink at all: `process_link_field` rewrites
	 * every Link field to fieldtype "Autocomplete" server-side, with the option
	 * list baked in. ControlAutocomplete.validate() then does, unconditionally:
	 *
	 *     let valid_values = this.awesomplete._list.map((d) => d.value);
	 *
	 * `this.awesomplete` is created in setup_awesomplete(), which only runs for
	 * a control that actually has an <input> - and a **read-only** control has
	 * none. So validate() dereferences undefined and throws, from inside
	 * set_value() -> validate_and_set_in_model(), and the throw takes down
	 * whatever was walking the fields at the time.
	 *
	 * On /tasks/new?project=<name> that is the prefill itself:
	 * WebForm.set_default_values() calls set_values() over
	 * `{...field defaults, ...query params}`, the read-only `project` field is
	 * one of them, and the TypeError aborted the loop - so the Project the URL
	 * named never reached the form, and pressing Save produced a Task with no
	 * Project at all: invisible to the customer who had just created it, and
	 * pinned to nobody. Confirmed by rendering the page (jsdom): `doc.project`
	 * came back `undefined` with the query string set to a real project.
	 *
	 * The fix is the one line frappe's own control is missing. A control with no
	 * awesomplete has no option list to check the value against, which is
	 * exactly the case validate() already handles two lines further down
	 * (`if (!valid_values.length) return value;`) - so the value is returned
	 * unchanged, and every control that does have an awesomplete keeps frappe's
	 * behaviour untouched.
	 *
	 * Installed from the frappe.web_form property trap rather than from the
	 * dispatch: this needs the class, which web_form.bundle.js defines, and the
	 * trap fires inside WebForm's constructor - after that bundle has loaded and
	 * before make() or set_default_values() has run. */
	function guard_readonly_autocomplete() {
		var cls = frappe.ui && frappe.ui.form && frappe.ui.form.ControlAutocomplete;
		if (!cls || !cls.prototype || cls.prototype.__portal_validate_guarded) return;
		cls.prototype.__portal_validate_guarded = true;

		var original = cls.prototype.validate;
		cls.prototype.validate = function (value) {
			if (!this.awesomplete || !this.awesomplete._list) return value;
			return original.call(this, value);
		};
	}

	/* A Select the form is holding a value it cannot show.
	 *
	 * WebForm.set_default_values() seeds a NEW form from `{...field defaults,
	 * ...query params}` - query params last, so a URL parameter always beats the
	 * field's own default. On /tasks/new the Project field is a Select of the
	 * customer's own projects (overrides/task_project_field.py), and a
	 * `?project=` naming anything else - another customer's project, a stale
	 * link, or erpnext's own dead /projects page, which links to
	 * /tasks/new?project=<project_NAME> and so never names a real record -
	 * leaves that Select in a state frappe's own control does not recover from:
	 *
	 *   set_formatted_input() sets $input.val(<unknown>), and jQuery answers an
	 *   unmatched value on a <select> by deselecting everything (selectedIndex
	 *   -1). Its own correction one line later is `if (value && input_value &&
	 *   value !== input_value) set_model_value(input_value)` - and input_value
	 *   is `null` for a select with nothing selected, so the branch is skipped
	 *   and the model keeps the phantom value behind a blank box.
	 *
	 * Visibly that is a required field showing nothing, refusing to submit
	 * ("Mandatory fields required: Project") and offering no clue why - instead
	 * of the first project pre-selected, which is what every other way of
	 * reaching the page gives. So a Select left with nothing selected but
	 * options to choose from is put back on its first option: the default the
	 * page would have had with no query string at all.
	 *
	 * Nothing is widened by this: the option list is the server's, and a value
	 * outside it was never going to be accepted (the save path refuses it -
	 * overrides/task_milestone.py::_check_own_project). This only stops the page
	 * from *carrying* one.
	 *
	 * Scoped to set_default_values(), which frappe calls on a **new** form and
	 * only there - existing documents are seeded by set_field_values() instead.
	 * That boundary is the whole safety argument: on a new form the only source
	 * of a value is a default or a query parameter, so falling back to the first
	 * option can never overwrite something a customer typed or a document
	 * stored. (The reverse - a read-only Select quietly resetting itself to a
	 * default on a *stored* document - is the bug already fixed on the server in
	 * overrides/portal_read_only_forms.py, and this must not become the client
	 * half of it.)
	 *
	 * set_values() is asynchronous and set_default_values() does not return its
	 * promise, so the correction is hung off set_values() itself, with a flag to
	 * say which call it belongs to. By the time that promise settles, frappe's
	 * own set_input() pass has run - which is what re-blanks the select - so
	 * this sees the state the user would. */
	function guard_select_defaults(form) {
		if (!form || typeof form.set_default_values !== "function") return;
		if (typeof form.set_values !== "function") return;
		if (form.__portal_select_defaults_guarded) return;
		form.__portal_select_defaults_guarded = true;

		var original_defaults = form.set_default_values.bind(form);
		var original_values = form.set_values.bind(form);
		var seeding = false;

		function correct() {
			(form.fields_list || []).forEach(function (control) {
				if (!control || !control.df || control.df.fieldtype !== "Select") return;
				// No $input at all is a read-only control: it renders its value
				// as text and has nothing to select.
				var $input = control.$input;
				if (!$input || !$input.length) return;
				if ($input.get(0).selectedIndex !== -1) return;
				var $first = $input.find("option").first();
				if (!$first.length) return;
				// The FieldGroup method, not the control's own: it writes the
				// model AND the input, which is the pair that is out of step.
				form.set_value(control.df.fieldname, $first.val());
			});
		}

		form.set_default_values = function () {
			seeding = true;
			try {
				return original_defaults();
			} finally {
				seeding = false;
			}
		};

		form.set_values = function (dict) {
			var promise = original_values(dict);
			if (seeding) {
				Promise.resolve(promise)
					.then(correct)
					.catch(function (e) { log(e, "select defaults"); });
			}
			return promise;
		};
	}

	/* "Not Saved" on a page with no Save button.
	 *
	 * frappe's WebForm gates its Save and Discard actions on `is_new ||
	 * in_edit_mode` but registers the change listener that marks the form dirty
	 * unconditionally (setup_listeners -> make_form_dirty). On a read-only
	 * record page that listener still fires, because controls normalise their
	 * own values as they render and frappe's base control treats a normalised
	 * value as a change (validate_and_set_in_model compares with ===):
	 *
	 *   - Task    expected_time  0  ->  "0"   (Float, read-only)
	 *             is_milestone   0  ->  "0"   (Check, read-only)
	 *   - Issue   status  "Replied" -> "Open" (Select falling back to its
	 *                                          web-form default)
	 *             via_customer_portal 0 -> "1"
	 *
	 * — all four during the initial render, before the user has touched
	 * anything. So every visit to /tasks/<name> and /issues/<name> opened with
	 * an orange "Not Saved" pill that no action on the page could clear, and
	 * frappe.form_dirty left true, which also puts a spurious "Discard?"
	 * confirmation in front of the Discard button in edit mode.
	 *
	 * The rule installed here is the one the pill is meant to express: a form is
	 * unsaved because a **person** changed something. So make_form_dirty is a
	 * no-op until a real input event has been seen, and a no-op forever in view
	 * mode, where there is nothing to save at all. Everything after that first
	 * keypress or pointer press behaves exactly as frappe wrote it.
	 *
	 * The instance is claimed through a property trap on frappe.web_form rather
	 * than by waiting for it: WebForm's constructor assigns `frappe.web_form =
	 * this` as its first statement and make() - which is where the spurious
	 * changes happen - runs immediately after, so anything that polls is already
	 * too late. Installed synchronously from the dispatch below, which runs
	 * before web_form.bundle.js for the same reason install_defaults_shim does.
	 *
	 * The interaction listeners are the events a human must produce *before* a
	 * value can change: a key, a pointer press, a paste. Deliberately not
	 * `input`/`change` themselves, which is what a control normalising itself
	 * emits. They are on `document` in the capture phase because two of the
	 * controls that set values - the Attach dialog and the date picker - live
	 * outside the form element. */
	function claim_web_form() {
		if (!window.frappe || frappe.__portal_web_form_claimed) return;
		frappe.__portal_web_form_claimed = true;

		var interacted = false;
		["pointerdown", "mousedown", "touchstart", "keydown", "paste"].forEach(function (name) {
			document.addEventListener(name, function () { interacted = true; }, true);
		});

		/* The document as the SERVER sent it, before any control has touched it.
		 *
		 * frappe.reference_doc is not a snapshot - it is the object the form
		 * writes into. set_model_value() does `this.doc[fieldname] = value` for
		 * every control, including the read-only ones, so the same
		 * normalisation that produced the spurious dirty flag above also
		 * *rewrites the document in memory*. On /issues/<name> that is not
		 * cosmetic: the Status field carries `default: "Open"` in erpnext's own
		 * issues Web Form, so opening a Replied issue left
		 * frappe.reference_doc.status === "Open" - and anything reading it
		 * afterwards, this file's own status pill included, showed the wrong
		 * status for the document the page is displaying.
		 *
		 * Taken here because this setter runs inside WebForm's constructor,
		 * which assigns `frappe.web_form = this` before prepare() hands it the
		 * doc and before make() renders a single control. A shallow copy is
		 * enough: every field the portal reads off it is a scalar. */
		function snapshot_reference_doc() {
			if (frappe.__portal_reference_doc) return;
			if (!frappe.reference_doc) return;
			frappe.__portal_reference_doc = $.extend({}, frappe.reference_doc);
		}

		function guard(form) {
			if (!form || typeof form.make_form_dirty !== "function") return;
			if (form.__portal_dirty_guarded) return;
			form.__portal_dirty_guarded = true;

			var original = form.make_form_dirty.bind(form);
			form.make_form_dirty = function () {
				// in_view_mode is copied onto the instance by prepare(), which
				// runs after this trap - read at call time, not at install time.
				if (form.in_view_mode) return;
				if (!interacted) return;
				return original();
			};
		}

		var instance;
		try {
			Object.defineProperty(frappe, "web_form", {
				configurable: true,
				enumerable: true,
				get: function () { return instance; },
				set: function (value) {
					instance = value;
					snapshot_reference_doc();
					guard_readonly_autocomplete();
					guard_select_defaults(value);
					guard(value);
				},
			});
		} catch (e) {
			// A browser that refuses the property claim keeps frappe's own
			// behaviour, pill and all - never a broken page.
			log(e, "web form claim");
		}
	}

	/* The document the page is showing, as the server sent it - see
	 * snapshot_reference_doc() in claim_web_form(). Falls back to the live
	 * object, which is right for anything that reads it before a control has
	 * had a chance to normalise a value, and no worse than the status quo
	 * afterwards. */
	function record_doc() {
		return frappe.__portal_reference_doc || frappe.reference_doc;
	}

	/* The Status field on a record page, as the same pill its list row shows.
	 *
	 * A read-only control renders its value into `.control-value` through
	 * frappe.format, which for a Select is the bare word. Replacing the contents
	 * of that one element - rather than the control - keeps the label, the
	 * layout and every other field exactly as frappe rendered them.
	 *
	 * Re-applied through a MutationObserver because a control re-renders itself
	 * on any refresh() (a dependency re-evaluating, an edit being discarded).
	 * The early return on an existing pill is what stops the observer's own
	 * writes from re-triggering it. */
	function paint_record_status(doctype) {
		var $body = $(".web-form-body");
		if (!$body.length || !INDICATORS[doctype]) return;

		function paint(force) {
			var doc = record_doc();
			if (!doc || !doc.status) return;
			var $value = $body
				.find('.frappe-control[data-fieldname="status"] .control-value')
				.first();
			if (!$value.length) return;
			// `force` is set by set_status_colors() when a configured colour map
			// lands after the pill was already drawn (CRM Deal). Without it the
			// early return below - which is what stops the MutationObserver
			// re-triggering on this function's own writes - would also pin the
			// pill to the grey fallback for the life of the page.
			if (!force && $value.find(".indicator-pill").length) return;
			// `.control-value` is in the markup of every control and hidden
			// whenever the field is writable (base_input's refresh toggles it
			// against `.control-input`). On /tasks/<name>/edit Status IS
			// writable - the tasks Web Form does not mark it read-only - and a
			// pill painted into a hidden element there would be a pill nobody
			// can see, over a select the user is meant to use.
			if ($value.css("display") === "none") return;
			var html = status_pill_html(doctype, doc);
			if (!html) return;
			$value.addClass("portal-status-value").html(html);
		}

		paint();
		repaint_record_status = paint;

		if (!window.MutationObserver) return;
		var observer = new MutationObserver(function () { paint(); });
		observer.observe($body.get(0), { childList: true, subtree: true });
	}

	/* Currency amounts on a record page, with their symbol.
	 *
	 * frappe.format -> format_currency reads the symbol, the number format and
	 * the fraction units out of locals[":Currency"]. The list pages fill that
	 * from get_meta's response; a record page calls no such endpoint, so every
	 * amount on /my-orders/<name> printed the currency code ("INR 29,980.00")
	 * while the same amount on /my-orders/list, one click earlier, printed
	 * "₹ 29,980.00".
	 *
	 * Only pages that actually show an amount pay for the request: Task, Issue
	 * and Project record pages have no Currency control and skip it entirely.
	 * The already-rendered controls are refreshed afterwards, because they
	 * formatted their value before the rows arrived. */
	function load_currency_docs(doctype) {
		var $currency = $('.web-form-body .frappe-control[data-fieldtype="Currency"]');
		if (!$currency.length) return Promise.resolve();

		return frappe
			.call({
				method: "plushvie_portal.web.list_api.get_currency_docs",
				type: "GET",
				args: { doctype: doctype },
			})
			.then(function (r) {
				/* Filed into locals directly rather than through
				 * frappe.model.sync: that function lives in
				 * frappe/model/sync.js, which is in neither
				 * frappe-web.bundle.js nor web_form.bundle.js - it is the first
				 * entry in COMPONENTS above precisely because the list routes
				 * have to fetch it. Guarding on it here made this a silent
				 * no-op on exactly the pages it was written for. For a
				 * ":Currency" row add_to_locals() does nothing more than the
				 * assignment below (it has no child tables and no meta), so
				 * this is that function's whole behaviour for this input, not
				 * an approximation of it. */
				((r && r.docs) || []).forEach(function (doc) {
					if (!doc || !doc.doctype || !doc.name) return;
					if (!locals[doc.doctype]) locals[doc.doctype] = {};
					locals[doc.doctype][doc.name] = doc;
				});
				var payload = (r && r.message) || {};
				var precision = payload.currency_precision;
				if (precision) install_defaults_shim({ currency_precision: precision });
				// Rides along on this request rather than costing one of its
				// own; repaints the status pill if it was drawn already.
				set_status_colors(doctype, payload.status_colors);

				var form = frappe.web_form;
				if (!form || !form.fields_list) return;
				form.fields_list.forEach(function (control) {
					if (control.df && control.df.fieldtype === "Currency" && control.refresh) {
						control.refresh();
					}
				});
			})
			.catch(function (e) {
				// The code-instead-of-symbol rendering is a cosmetic loss, not a
				// broken page: leave what frappe already rendered.
				log(e, "currency docs");
			});
	}

	/* Everything the desk's Project form shows and a Web Form cannot.
	 *
	 * One request, to plushvie_portal.web.project_api.get_project_summary -
	 * see that module for what it returns and how it is scoped. Rendered as a
	 * panel appended after the form card, so a failure here costs the panel and
	 * never the record page: the whole thing is inside a .catch, and the page is
	 * fully usable without it.
	 *
	 * The Tasks and Issues links are the portal's answer to the desk's
	 * click-through from a Project to its linked documents. They go to this
	 * portal's own scoped lists with the project pre-filtered
	 * (/tasks/list?project=<name>) - a URL the list pages already understand,
	 * because make_url_codec() reads exactly that shape back into the filter
	 * toolbar, and portal/scoping.py::_scope_task then verifies the project is
	 * one this user may see. Nothing new had to be taught to either end. */
	function init_project_record(project) {
		var $container = $(".web-form-container");
		if (!$container.length) return;

		return frappe
			.call({
				method: "plushvie_portal.web.project_api.get_project_summary",
				type: "GET",
				args: { project: project },
			})
			.then(function (r) {
				var data = (r && r.message) || null;
				if (!data) return;
				render_project_panel($container, project, data);
			})
			.catch(function (e) { log(e, "project summary"); });
	}

	function render_project_panel($container, project, data) {
		var doc = data.project || {};
		var percent = Math.max(0, Math.min(100, Math.round(flt(doc.percent_complete))));

		var $panel = $('<div class="portal-record-panel"></div>');

		// --- progress -------------------------------------------------------
		var $progress = $('<div class="portal-project-progress"></div>').appendTo($panel);
		$('<div class="portal-panel-head"></div>')
			.append($("<h5></h5>").text(__("Progress")))
			.append($('<span class="portal-progress-value"></span>').text(percent + "%"))
			.appendTo($progress);
		$(
			'<div class="portal-progress-track" role="progressbar" aria-valuemin="0" aria-valuemax="100">' +
				'<div class="portal-progress-bar"></div>' +
			"</div>"
		)
			.attr("aria-valuenow", percent)
			.find(".portal-progress-bar")
			.css("width", percent + "%")
			.end()
			.appendTo($progress);
		if (doc.percent_complete_method) {
			$('<p class="portal-panel-note text-muted"></p>')
				.text(__("Calculated by {0}", [__(doc.percent_complete_method)]))
				.appendTo($progress);
		}

		// --- linked documents ----------------------------------------------
		var tasks = data.tasks || {};
		var issues = data.issues || {};
		var $links = $('<div class="portal-project-links"></div>').appendTo($panel);

		build_link_card($links, {
			href: "/tasks/list?project=" + encodeURIComponent(project),
			label: __("Tasks"),
			count: cint(tasks.total),
			pills: [
				tasks.open ? [__("{0} open", [cint(tasks.open)]), "orange"] : null,
				tasks.overdue ? [__("{0} overdue", [cint(tasks.overdue)]), "red"] : null,
				tasks.completed ? [__("{0} completed", [cint(tasks.completed)]), "green"] : null,
			],
		});
		build_link_card($links, {
			href: "/issues/list?project=" + encodeURIComponent(project),
			label: __("Issues"),
			count: cint(issues.total),
			pills: [
				issues.open ? [__("{0} open", [cint(issues.open)]), "orange"] : null,
				issues.closed ? [__("{0} closed", [cint(issues.closed)]), "green"] : null,
			],
		});

		// --- activity -------------------------------------------------------
		var $activity = $('<div class="portal-project-activity"></div>').appendTo($panel);
		$("<h5></h5>").text(__("Activity")).appendTo($activity);
		var entries = data.activity || [];
		if (!entries.length) {
			$('<p class="portal-panel-note text-muted"></p>')
				.text(__("No activity yet"))
				.appendTo($activity);
		} else {
			var $list = $('<ul class="portal-activity-list"></ul>').appendTo($activity);
			entries.forEach(function (entry) {
				render_activity_entry($list, entry);
			});
		}

		// Before the comment box frappe renders for this Web Form, so the page
		// reads: the record, what happened to it, then the conversation about it.
		var $comments = $container.children(".comments").first();
		if ($comments.length) $panel.insertBefore($comments);
		else $panel.appendTo($container);
	}

	function build_link_card($parent, opts) {
		var $card = $('<a class="portal-link-card"></a>')
			.attr("href", opts.href)
			.appendTo($parent);
		$('<span class="portal-link-count"></span>').text(opts.count).appendTo($card);
		$('<span class="portal-link-label"></span>').text(opts.label).appendTo($card);
		var $pills = $('<span class="portal-link-pills"></span>').appendTo($card);
		(opts.pills || []).forEach(function (pill) {
			if (!pill) return;
			$('<span class="indicator-pill"></span>')
				.addClass(pill_color(pill[1]))
				.append($("<span></span>").text(pill[0]))
				.appendTo($pills);
		});
	}

	/* One timeline row. `html` is the only field rendered as markup, and only
	 * for a comment - whose content frappe itself stores and renders as HTML on
	 * this very page (the comment list below this panel). Everything else -
	 * names, subjects, field values - is set with .text(), so a document title
	 * can never become markup here. */
	function render_activity_entry($list, entry) {
		var $item = $('<li class="portal-activity-item"></li>').appendTo($list);

		var $head = $('<div class="portal-activity-head"></div>').appendTo($item);
		if (entry.by) $('<span class="portal-activity-by"></span>').text(entry.by).appendTo($head);
		$('<span class="portal-activity-title"></span>').text(entry.title || "").appendTo($head);
		if (entry.on) {
			// comment_when returns frappe's own <span class="frappe-timestamp">
			// markup ("2 days ago", with the exact time in its title) - the same
			// relative timestamp the desk timeline shows. It is built from a
			// server-generated timestamp string, so it is inserted as markup;
			// falling back to the raw value if that helper is not in this
			// page's bundle.
			var $when = $('<span class="portal-activity-time text-muted"></span>').appendTo($head);
			if (frappe.datetime && frappe.datetime.comment_when) {
				$when.html(frappe.datetime.comment_when(entry.on));
			} else {
				$when.attr("title", entry.on).text(entry.on);
			}
		}

		if (entry.link && entry.text) {
			$('<div class="portal-activity-body"></div>')
				.append($("<a></a>").attr("href", entry.link).text(entry.text))
				.appendTo($item);
		} else if (entry.text) {
			$('<div class="portal-activity-body"></div>').text(entry.text).appendTo($item);
		}

		if (entry.html) {
			$('<div class="portal-activity-body"></div>').html(entry.html).appendTo($item);
		}

		if (entry.changes && entry.changes.length) {
			var $changes = $('<ul class="portal-activity-changes"></ul>').appendTo($item);
			entry.changes.forEach(function (change) {
				$("<li></li>")
					.text(
						change.old
							? __("{0}: {1} → {2}", [change.label, change.old, change.new])
							: __("{0}: {1}", [change.label, change.new])
					)
					.appendTo($changes);
			});
		}
	}

	/* Which doctype a record page is showing.

	 * Read off the page's own data, not off the URL: web_form.html's inline
	 * script assigns frappe.web_form_doc before web_form.bundle.js runs, and
	 * everything that calls this waits for the form to have rendered. Same
	 * reasoning as init_web_form_list()'s - a route this file does not
	 * recognise must not be able to cost a portal page its behaviour. */
	function record_doctype() {
		var doc = window.frappe && frappe.web_form_doc;
		return (doc && doc.doc_type) || null;
	}

	/* The record name in /<route>/<name> and /<route>/<name>/edit; null on
	 * /<route>/new and on the bare route. Same parse show_record_id() does. */
	function record_name(path) {
		var parts = path.split("/").filter(Boolean);
		if (parts[parts.length - 1] === "edit") parts.pop();
		if (parts.length < 2) return null;
		var docname = decodeURIComponent(parts[parts.length - 1]);
		if (docname === "new" || docname === "list") return null;
		return docname;
	}

	// =============================================================================
	// Video gallery: /videos/list
	//
	// Marked `gallery` in PORTAL_SECTIONS rather than treated as a list.
	// /tasks/list and friends render a desk-style data table via frappe's
	// WebFormList, and init_web_form_list above exists to bolt desk filter/sort
	// behaviour onto that table - a video catalogue is a card grid with a media
	// player, not a table, so forcing it through that machinery would mean
	// bending code written for a different view, for no shared benefit. This
	// section is a small, independent renderer instead.
	//
	// It reuses the same endpoint everything else here uses
	// (frappe.www.list.get_list_data, with "Video" allowlisted in
	// list_api.ALLOWED_DOCTYPES and scoped by portal/scoping.py::_scope_video)
	// so the data layer - and its access control - is not reimplemented.
	//
	// Frappe's own stock web_list.html + WebFormList still mount on this route
	// regardless (that is core frappe behaviour for any Web Form list, nothing
	// this app controls) and still fire their own harmless get_list_data call
	// in the background. Rather than take that list over the way the table
	// routes do, this simply hides its output - .web-list-filters/-table/-footer
	// are already in the DOM, server-rendered by web_list.html, by the time this
	// runs (from inside the WebFormList constructor, via take_over), so no
	// wait_for is needed to reach them.
	// =============================================================================

	/* The 11-character id out of any of the URL shapes YouTube actually issues.
	 * Video.url is the only field the backend reliably fills in - tracking is
	 * off on this site, so Video.youtube_video_id and .image are never set
	 * (the two portal fields are Custom Fields - hooks.py::fixtures) - so the id
	 * is parsed here
	 * rather than trusted from those fields. */
	function extract_youtube_id(url) {
		if (!url) return null;
		var m = String(url).match(
			/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
		);
		return m ? m[1] : null;
	}

	function zero_pad(n) {
		n = String(n);
		return n.length < 2 ? "0" + n : n;
	}

	/* Video.duration is a Duration field - total seconds - or empty; most
	 * videos will have no value at all, so callers only show this when it is
	 * present. */
	function format_duration(value) {
		var total = Math.max(0, Math.round(Number(value) || 0));
		var h = Math.floor(total / 3600);
		var m = Math.floor((total % 3600) / 60);
		var s = total % 60;
		return h ? h + ":" + zero_pad(m) + ":" + zero_pad(s) : m + ":" + zero_pad(s);
	}

	/* row.image is a hidden Attach Image field almost nothing ever sets (see
	 * video.json - staff would have to go out of their way to reach it); the
	 * YouTube-hosted thumbnail is the real, reliable source, and works with no
	 * API key and regardless of whether YouTube tracking is enabled. */
	function video_thumb_url(row, youtube_id) {
		if (row.image) return row.image;
		if (youtube_id) return "https://img.youtube.com/vi/" + youtube_id + "/hqdefault.jpg";
		return null;
	}

	var $video_modal = null;
	var $video_modal_opener = null;

	function close_video_modal() {
		if (!$video_modal) return;
		// Empty the frame, not just hide it - an iframe keeps playing audio
		// after its container is hidden, only removing it stops playback.
		$video_modal.find(".portal-video-modal-frame").empty();
		$video_modal.removeClass("is-open").attr("aria-hidden", "true");
		if ($video_modal_opener && $video_modal_opener.length) {
			$video_modal_opener.trigger("focus");
		}
		$video_modal_opener = null;
	}

	function ensure_video_modal() {
		if ($video_modal) return $video_modal;

		$video_modal = $(
			'<div class="portal-video-modal-overlay" aria-hidden="true">' +
				'<div class="portal-video-modal" role="dialog" aria-modal="true">' +
					'<button type="button" class="portal-video-modal-close"></button>' +
					'<div class="portal-video-modal-frame"></div>' +
					'<div class="portal-video-modal-info">' +
						'<h3 class="portal-video-modal-title"></h3>' +
						'<div class="portal-video-modal-category"></div>' +
						'<div class="portal-video-modal-desc"></div>' +
					"</div>" +
				"</div>" +
			"</div>"
		).appendTo("body");

		$video_modal.find(".portal-video-modal-close").attr("aria-label", __("Close")).text("×");

		// Close on backdrop click, but not on a click inside the panel itself.
		$video_modal.on("click", function (e) {
			if (e.target === $video_modal[0]) close_video_modal();
		});
		$video_modal.find(".portal-video-modal-close").on("click", close_video_modal);
		$(document).on("keydown", function (e) {
			if (e.key === "Escape" && $video_modal.hasClass("is-open")) close_video_modal();
		});

		return $video_modal;
	}

	function open_video_modal(row, youtube_id, $opener) {
		if (!youtube_id) return;
		var $modal = ensure_video_modal();
		$video_modal_opener = $opener;

		var $frame = $modal.find(".portal-video-modal-frame").empty();
		$("<iframe></iframe>")
			.attr({
				src: "https://www.youtube.com/embed/" + encodeURIComponent(youtube_id) + "?autoplay=1&rel=0",
				title: row.title || "",
				frameborder: "0",
				allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
				allowfullscreen: "allowfullscreen",
			})
			.appendTo($frame);

		$modal.find(".portal-video-modal-title").text(row.title || "");
		var $cat = $modal.find(".portal-video-modal-category").empty();
		if (row.portal_category) $cat.text(row.portal_category);

		// description is a Text Editor field staff author in the desk, not
		// something a portal visitor ever writes - same trust level as the
		// FAQ answer body and the record page's activity entries, which this
		// file already renders with .html() for the same reason.
		var $desc = $modal.find(".portal-video-modal-desc").empty();
		if (row.description) $desc.html(row.description);

		$modal.addClass("is-open").attr("aria-hidden", "false");
		$modal.find(".portal-video-modal-close").trigger("focus");
	}

	function render_video_cards($grid, rows) {
		$grid.empty();
		rows.forEach(function (row) {
			var youtube_id = extract_youtube_id(row.url);
			var thumb = video_thumb_url(row, youtube_id);

			var $card = $('<div class="portal-video-card" tabindex="0" role="button"></div>')
				.attr("data-category", row.portal_category || "")
				.attr("aria-label", row.title || "")
				.appendTo($grid);

			var $thumb = $('<div class="portal-video-thumb"></div>').appendTo($card);
			if (thumb) {
				$("<img>").attr("src", thumb).attr("alt", "").appendTo($thumb);
			} else {
				$thumb.addClass("is-fallback");
			}
			$('<span class="portal-video-play-icon" aria-hidden="true"></span>').appendTo($thumb);
			if (row.duration) {
				$('<span class="portal-video-duration"></span>')
					.text(format_duration(row.duration))
					.appendTo($thumb);
			}

			var $body = $('<div class="portal-video-body"></div>').appendTo($card);
			$('<div class="portal-video-title"></div>').text(row.title || "").appendTo($body);
			if (row.portal_category) {
				$('<span class="portal-video-category"></span>').text(row.portal_category).appendTo($body);
			}

			function activate() {
				open_video_modal(row, youtube_id, $card);
			}
			$card.on("click", activate);
			$card.on("keydown", function (e) {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					activate();
				}
			});
		});
	}

	/* "All" plus one chip per distinct category actually present in this
	 * user's own rows - never a separate query over Help Category, which would
	 * be able to name a category none of their videos carry. Filters the cards
	 * already on screen; there is no re-fetch, because the whole catalogue was
	 * already fetched in one bounded call (see init_video_gallery). */
	function render_category_filter($bar, rows, $grid) {
		var categories = [];
		rows.forEach(function (row) {
			if (row.portal_category && categories.indexOf(row.portal_category) === -1) {
				categories.push(row.portal_category);
			}
		});

		$bar.empty();
		if (!categories.length) {
			$bar.hide();
			return;
		}
		categories.sort();
		$bar.show();

		$('<button type="button" class="portal-video-chip active" data-category=""></button>')
			.text(__("All"))
			.appendTo($bar);
		categories.forEach(function (cat) {
			$('<button type="button" class="portal-video-chip"></button>')
				.attr("data-category", cat)
				.text(cat)
				.appendTo($bar);
		});

		$bar.on("click", ".portal-video-chip", function () {
			var $chip = $(this);
			$bar.find(".portal-video-chip").removeClass("active");
			$chip.addClass("active");
			var cat = $chip.attr("data-category");
			$grid.find(".portal-video-card").each(function () {
				var $card = $(this);
				$card.toggle(!cat || $card.attr("data-category") === cat);
			});
		});
	}

	function render_video_skeleton($grid, count) {
		$grid.empty();
		for (var i = 0; i < count; i++) {
			var $card = $('<div class="portal-video-card is-skeleton"></div>').appendTo($grid);
			$('<div class="portal-video-thumb"></div>').appendTo($card);
			var $body = $('<div class="portal-video-body"></div>').appendTo($card);
			$('<div class="portal-video-title"></div>').appendTo($body);
		}
	}

	function render_video_empty_state($wrap) {
		$wrap.find(".portal-video-grid, .portal-video-filters").remove();
		$('<div class="empty-apps-state portal-video-empty"></div>')
			.append(
				$("<img>")
					.attr("src", "/assets/frappe/images/ui-states/list-empty-state.svg")
					.attr("alt", "")
					.addClass("empty-list-icon")
			)
			.append($('<p class="small mb-2"></p>').text(__("No videos yet")))
			.appendTo($wrap);
	}

	function init_video_gallery() {
		["web-list-filters", "web-list-table", "web-list-footer"].forEach(function (cls) {
			var el = document.querySelector("." + cls);
			if (el) el.style.display = "none";
		});

		var $container = $(".web-list-container");
		if (!$container.length) return;

		var $wrap = $('<div class="portal-video-gallery"></div>').appendTo($container);
		var $filterBar = $('<div class="portal-video-filters"></div>').appendTo($wrap);
		var $grid = $('<div class="portal-video-grid"></div>').appendTo($wrap);

		render_video_skeleton($grid, 6);

		frappe
			.call({
				method: "frappe.www.list.get_list_data",
				args: {
					doctype: "Video",
					// The form's own name, not a literal: which Web Form record
					// serves this section is portal/sections.py's business, and
					// this page already has the answer in hand.
					web_form_name: (frappe.web_form_doc || {}).name,
					limit_start: 0,
					limit: 100,
					order_by: "modified desc",
				},
			})
			.then(function (r) {
				var rows = (r && r.message) || [];
				if (!rows.length) {
					render_video_empty_state($wrap);
					return;
				}
				render_category_filter($filterBar, rows, $grid);
				render_video_cards($grid, rows);
			})
			.catch(function (e) {
				log(e, "video gallery");
				render_video_empty_state($wrap);
			});
	}

	// -------------------------------------------------------------- dispatch

	/* The portal sections this file upgrades, keyed by DOCTYPE.
	 *
	 * Keyed by doctype and not by route, which is the whole point: the route a
	 * section lives at is decided by a Web Form record, and a Web Form record
	 * can be renamed, recreated or re-routed in the desk. When this map was
	 * keyed on window.location, doing any of that took the filter toolbar away
	 * with no error and no clue - which is exactly what happened to /tasks/list
	 * on this bench, where the form was unpublished and two copies of it were
	 * made on routes of their own. The doctype is read off the WebFormList
	 * instance instead (see init_web_form_list), so the section is recognised
	 * wherever its form happens to be served from.
	 *
	 * Server side, the record names and routes are in
	 * plushvie_portal/web/sections.py, which is also what ships the Web Form
	 * JSON that creates them. Every entry here needs a matching scope in
	 * portal/scoping.py and a matching name in list_api.ALLOWED_DOCTYPES;
	 * without both, the endpoint hands the request back to stock frappe and the
	 * list stays unfiltered.
	 *
	 * So this map is deliberately SHORTER than sections.py's: sections.py answers
	 * "which Web Form serves this section" for all nine, and Address is one of
	 * them - but Address has no scope in portal/scoping.py and is not in
	 * ALLOWED_DOCTYPES, so /address/list must keep frappe's own list behaviour
	 * untouched. Adding it here would put a filter toolbar over rows this app
	 * does not scope.
	 *
	 * Everything in an entry is presentation. `new_label` overrides the header
	 * button, which web_list.html always renders as "New" (the label is baked
	 * into frappe's template, and a Web Form's own button_label applies to the
	 * form's submit button, not to this). `doc_label` is the customer's word for
	 * the doctype, used wherever frappe would otherwise print the doctype's own
	 * name at them - the empty state's "No {0} found" is the only such place
	 * today. `gallery` marks the one section that is not a table at all. */
	var PORTAL_SECTIONS = {
		Task: {},
		Issue: {},
		Project: {},
		"Sales Order": {},
		"Sales Invoice": {},
		Quotation: { new_label: "Request a Quotation" },
		// The portal's Inquiry section, over the crm app's CRM Deal. The
		// customer-facing name for the section is "Inquiry" throughout - the Web
		// Form's title, its breadcrumb and this button - because "Deal" is the
		// sales team's word for it, and "CRM Deal" doubly so.
		"CRM Deal": {
			doc_label: "Inquiry",
			new_label: "Raise an Inquiry",
		},
		// A video catalogue is a card grid with a media player, not a table, so
		// it gets its own renderer rather than the desk-style list machinery.
		// See init_video_gallery().
		Video: { gallery: true },
	};

	/* The plain portal list routes this file owns, and the doctype each one
	 * lists. `detail_href` is optional and defaults to `<route>/<name>` - see
	 * row_href() above. Every entry needs a matching scope in
	 * portal/scoping.py and a matching name in list_api.ALLOWED_DOCTYPES;
	 * without both, the endpoint hands the request back to stock frappe and
	 * the list stays unfiltered. */
	var PORTAL_LIST_ROUTES = {
		"/orders": { doctype: "Sales Order" },
		"/invoices": { doctype: "Sales Invoice" },
		"/quotations": {
			doctype: "Quotation",
			/* erpnext's own server-rendered Quotation list, still reachable at
			 * this URL so past quotations stay readable.
			 *
			 * The button used to point at /quotation/new, the portal's own
			 * "Request a Quotation" Web Form. That form is **unpublished** - the
			 * Quotation section is on hold and raising an inquiry replaced it -
			 * and an unpublished Web Form's routes 404, so the button had
			 * nowhere to go. It points at the section that took the job over.
			 * A route with no `create` entry simply gets no button. */
			create: { href: "/inquiry/new", label: __("Raise an Inquiry") },
		},
		"/project": {
			doctype: "Project",
			/* erpnext's own Project detail page is templates/pages/projects.html,
			 * reached as /projects?project=<name>. That URL is dead: the
			 * `projects` Web Form owns the /projects route now, and WebFormPage is
			 * tried before TemplatePage (frappe/website/path_resolver.py), so the
			 * query-string page 301s to /projects/list and this row link went
			 * nowhere. The Web Form's own detail page is the one that works - and
			 * the one that fixes the long-standing 403 there, because
			 * has_web_form_permission consults frappe.has_website_permission,
			 * which erpnext's page never did. */
			detail_href: function (doc) {
				return "/projects/" + encodeURIComponent(doc.name);
			},
		},
	};

	var PATH = window.location.pathname.replace(/\/+$/, "");

	/* The *form* routes of those same Web Forms - /quotation/new,
	 * /quotation/SAL-QTN-0001, and the bare /quotation that redirects to the
	 * list. This file does not build those pages, frappe's own
	 * web_form.bundle.js does; it installs one shim on them and gets out of the
	 * way.
	 *
	 * The shim is frappe.defaults, and without it a Web Form cannot render a
	 * Currency value at all: frappe.format -> formatters.Currency ->
	 * frappe.meta.get_field_precision() reads
	 * frappe.defaults.get_default("currency_precision"), and frappe/defaults.js
	 * is in no website bundle - not frappe-web.bundle.js and not
	 * web_form.bundle.js. On the Quotation form that took out the entire items
	 * grid: the header row rendered and not one body row, because the throw
	 * aborted the forEach that renders them. With no user_defaults to read,
	 * get_default returns undefined and get_field_precision falls back to the
	 * currency's own number format - exactly what the desk does when no
	 * currency_precision override is set.
	 *
	 * Installed synchronously rather than behind wait_for, because it has to be
	 * in place before web_form.bundle.js runs: frappe/templates/base.html emits
	 * frappe-web.bundle.js (so `frappe` already exists here), then this file's
	 * web_include_js, then `{% block script %}` where the web form's own bundle
	 * goes. */
	function is_web_form_record_page() {
		return !!document.querySelector(".web-form-container");
	}

	/* The matching test for a Web Form LIST page. Both read the server-rendered
	 * markup rather than the URL: web_list.html emits .web-list-container and
	 * web_form.html emits .web-form-container, and frappe/templates/base.html
	 * puts the page content above this file's web_include_js, so both are
	 * already in the DOM when this runs. That is what makes the dispatch below
	 * independent of what a Web Form's route happens to be called. */
	function is_web_form_list_page() {
		return !!document.querySelector(".web-list-container");
	}

	/* The record ID, in the detail page header.
	 *
	 * web_form.html's header is `<h1>` the Web Form title over `<p>` the
	 * *document* title - which for Sales Order and Sales Invoice is the customer
	 * name, so the page showed a customer three times and the order number
	 * nowhere. The two forms that carried an "Order ID" / "Invoice ID" field to
	 * work around that could not be saved at all: `name` is not a DocField, so
	 * WebForm.validate rejects it (they only existed because reload_doc imports
	 * with frappe.flags.in_import, which skips that check).
	 *
	 * So the ID is put where it belongs for every portal record page at once,
	 * rather than as a field on some of them. Read off the path, which is the
	 * one place it is always available and needs no frappe internals: a Web
	 * Form's record routes are /<route>/<name> and /<route>/<name>/edit
	 * whatever <route> is called. Skipped when the subtitle already IS the ID (a
	 * doctype with no title field, e.g. Project), so nothing is ever shown
	 * twice. */
	function show_record_id(path) {
		var parts = path.split("/").filter(Boolean);
		if (parts[parts.length - 1] === "edit") parts.pop();
		if (parts.length < 2) return; // /<route>/list or /<route>/new
		var docname = decodeURIComponent(parts[parts.length - 1]);
		if (docname === "new" || docname === "list") return;

		var $title = $(".web-form-header .web-form-title");
		if (!$title.length || $title.find(".portal-doc-id").length) return;

		var $sub = $title.find("p").first();
		if ($sub.length && $sub.text().trim() === docname) return;

		var $id = $('<p class="portal-doc-id ellipsis"></p>').text(docname);
		if ($sub.length) $id.insertBefore($sub);
		else $title.append($id);
	}

	if (is_web_form_list_page()) {
		/* Every Web Form list on the site comes through here, including a
		 * client's own. Which one this is, is decided from the doctype of the
		 * WebFormList instance rather than from the URL, inside
		 * init_web_form_list -> take_over; a list this app does not serve is
		 * left exactly as frappe renders it.
		 *
		 * Deliberately NOT wrapped in wait_for: the instance has to be claimed
		 * synchronously, while this script is still the only one that has run
		 * (see claim_web_form_list). Everything that can wait waits inside. */
		init_web_form_list();
	} else if (is_web_form_record_page()) {
		// Both of these have to be in place before web_form.bundle.js runs -
		// see each function for why - so neither may wait for anything, and
		// neither can yet know the doctype. Both are harmless on a Web Form this
		// app does not serve: install_defaults_shim only fills in a boot value
		// the website has no source for at all, and claim_web_form only guards
		// frappe's own "Not Saved" pill and snapshots the document.
		if (window.frappe) {
			install_defaults_shim();
			claim_web_form();
		}
		wait_for(
			/* frappe.web_form_doc is part of the test, not just the header.
			 *
			 * The header is server-rendered ABOVE this script, so it is already
			 * in the DOM and wait_for's first check passes synchronously - while
			 * this file is still the only thing that has run, and before the
			 * page's own inline script (which is where frappe.web_form_doc is
			 * assigned) has executed. Waiting only for the header therefore read
			 * the doctype as null and silently skipped the status pill, the
			 * currency rows and the Project panel. Confirmed the hard way, in
			 * jsdom: _currencyDocCall and _projectApiCall were both 0 with the
			 * page otherwise fully rendered. */
			function () {
				return window.$ && window.frappe && frappe.web_form_doc && $(".web-form-header").length;
			},
			function () {
				show_record_id(PATH);

				var doctype = record_doctype();
				var docname = record_name(PATH);
				if (!doctype || !PORTAL_SECTIONS[doctype]) return; // not a section this app serves
				if (!docname) return; // /<route>/new has no record yet

				// The form is built by frappe's own frappe.ready() handler,
				// which has not necessarily run when the header appears; both
				// of these read what it rendered.
				wait_for(
					function () { return $(".web-form-body .frappe-control").length; },
					function () {
						paint_record_status(doctype);
						load_currency_docs(doctype);
						if (doctype === "Project") init_project_record(docname);
					}
				);
			}
		);
	} else if (PORTAL_LIST_ROUTES[PATH]) {
		wait_for(
			function () {
				return (
					window.frappe && frappe.ui && frappe.ui.form &&
					frappe.model && frappe.meta && window.$ && $(".page_content").length
				);
			},
			function () {
				load_components()
					.then(await_components)
					.then(function () {
						return Promise.all([ensure_make_control(), ensure_awesomplete()]);
					})
					.then(function () {
						init_portal_list(PORTAL_LIST_ROUTES[PATH].doctype, PORTAL_LIST_ROUTES[PATH]);
					})
					.catch(function (e) { log(e, "component load"); });
			}
		);
	}
})();
